/*
 *
 * Copyright (c) 2006-2014 Sam Collett (http://www.texotela.co.uk)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version 1.4.1
 * Demo: http://www.texotela.co.uk/code/jquery/numeric/
 *
 */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], factory);
  } else {
    factory(window.jQuery);
  }
})(function ($) {
  $.fn.numeric = function (config, callback) {
    if (typeof config === "boolean") {
      config = { decimal: config, negative: true, decimalPlaces: -1 };
    }
    config = config || {};
    if (typeof config.negative == "undefined") {
      config.negative = true;
    }
    var decimal = config.decimal === false ? "" : config.decimal || ".";
    var negative = config.negative === true ? true : false;
    var decimalPlaces =
      typeof config.decimalPlaces == "undefined" ? -1 : config.decimalPlaces;
    callback = typeof callback == "function" ? callback : function () {};
    return this.data("numeric.decimal", decimal)
      .data("numeric.negative", negative)
      .data("numeric.callback", callback)
      .data("numeric.decimalPlaces", decimalPlaces)
      .keypress($.fn.numeric.keypress)
      .keyup($.fn.numeric.keyup)
      .blur($.fn.numeric.blur);
  };
  $.fn.numeric.keypress = function (e) {
    var decimal = $.data(this, "numeric.decimal");
    var negative = $.data(this, "numeric.negative");
    var decimalPlaces = $.data(this, "numeric.decimalPlaces");
    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
    if (key == 13 && this.nodeName.toLowerCase() == "input") {
      return true;
    } else if (key == 13) {
      return false;
    }
    var allow = false;
    if ((e.ctrlKey && key == 97) || (e.ctrlKey && key == 65)) {
      return true;
    }
    if ((e.ctrlKey && key == 120) || (e.ctrlKey && key == 88)) {
      return true;
    }
    if ((e.ctrlKey && key == 99) || (e.ctrlKey && key == 67)) {
      return true;
    }
    if ((e.ctrlKey && key == 122) || (e.ctrlKey && key == 90)) {
      return true;
    }
    if (
      (e.ctrlKey && key == 118) ||
      (e.ctrlKey && key == 86) ||
      (e.shiftKey && key == 45)
    ) {
      return true;
    }
    if (key < 48 || key > 57) {
      var value = $(this).val();
      if (
        $.inArray("-", value.split("")) !== 0 &&
        negative &&
        key == 45 &&
        (value.length === 0 || parseInt($.fn.getSelectionStart(this), 10) === 0)
      ) {
        return true;
      }
      if (
        decimal &&
        key == decimal.charCodeAt(0) &&
        $.inArray(decimal, value.split("")) != -1
      ) {
        allow = false;
      }
      if (
        key != 8 &&
        key != 9 &&
        key != 13 &&
        key != 35 &&
        key != 36 &&
        key != 37 &&
        key != 39 &&
        key != 46
      ) {
        allow = false;
      } else {
        if (typeof e.charCode != "undefined") {
          if (e.keyCode == e.which && e.which !== 0) {
            allow = true;
            if (e.which == 46) {
              allow = false;
            }
          } else if (e.keyCode !== 0 && e.charCode === 0 && e.which === 0) {
            allow = true;
          }
        }
      }
      if (decimal && key == decimal.charCodeAt(0)) {
        if ($.inArray(decimal, value.split("")) == -1) {
          allow = true;
        } else {
          allow = false;
        }
      }
    } else {
      allow = true;
      if (decimal && decimalPlaces > 0) {
        var dot = $.inArray(decimal, $(this).val().split(""));
        if (dot >= 0 && $(this).val().length > dot + decimalPlaces) {
          allow = false;
        }
      }
    }
    return allow;
  };
  $.fn.numeric.keyup = function (e) {
    var val = $(this).val();
    if (val && val.length > 0) {
      var carat = $.fn.getSelectionStart(this);
      var selectionEnd = $.fn.getSelectionEnd(this);
      var decimal = $.data(this, "numeric.decimal");
      var negative = $.data(this, "numeric.negative");
      var decimalPlaces = $.data(this, "numeric.decimalPlaces");
      if (decimal !== "" && decimal !== null) {
        var dot = $.inArray(decimal, val.split(""));
        if (dot === 0) {
          this.value = "0" + val;
          carat++;
          selectionEnd++;
        }
        if (dot == 1 && val.charAt(0) == "-") {
          this.value = "-0" + val.substring(1);
          carat++;
          selectionEnd++;
        }
        val = this.value;
      }
      var validChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "-", decimal];
      var length = val.length;
      for (var i = length - 1; i >= 0; i--) {
        var ch = val.charAt(i);
        if (i !== 0 && ch == "-") {
          val = val.substring(0, i) + val.substring(i + 1);
        } else if (i === 0 && !negative && ch == "-") {
          val = val.substring(1);
        }
        var validChar = false;
        for (var j = 0; j < validChars.length; j++) {
          if (ch == validChars[j]) {
            validChar = true;
            break;
          }
        }
        if (!validChar || ch == " ") {
          val = val.substring(0, i) + val.substring(i + 1);
        }
      }
      var firstDecimal = $.inArray(decimal, val.split(""));
      if (firstDecimal > 0) {
        for (var k = length - 1; k > firstDecimal; k--) {
          var chch = val.charAt(k);
          if (chch == decimal) {
            val = val.substring(0, k) + val.substring(k + 1);
          }
        }
      }
      if (decimal && decimalPlaces > 0) {
        var dot = $.inArray(decimal, val.split(""));
        if (dot >= 0) {
          val = val.substring(0, dot + decimalPlaces + 1);
          selectionEnd = Math.min(val.length, selectionEnd);
        }
      }
      this.value = val;
      $.fn.setSelection(this, [carat, selectionEnd]);
    }
  };
  $.fn.numeric.blur = function () {
    var decimal = $.data(this, "numeric.decimal");
    var callback = $.data(this, "numeric.callback");
    var negative = $.data(this, "numeric.negative");
    var val = this.value;
    if (val !== "") {
      var re = new RegExp(
        "^" +
          (negative ? "-?" : "") +
          "\\d+$|^" +
          (negative ? "-?" : "") +
          "\\d*" +
          decimal +
          "\\d+$"
      );
      if (!re.exec(val)) {
        callback.apply(this);
      }
    }
  };
  $.fn.removeNumeric = function () {
    return this.data("numeric.decimal", null)
      .data("numeric.negative", null)
      .data("numeric.callback", null)
      .data("numeric.decimalPlaces", null)
      .unbind("keypress", $.fn.numeric.keypress)
      .unbind("keyup", $.fn.numeric.keyup)
      .unbind("blur", $.fn.numeric.blur);
  };
  $.fn.getSelectionStart = function (o) {
    if (o.type === "number") {
      return undefined;
    } else if (o.createTextRange && document.selection) {
      var r = document.selection.createRange().duplicate();
      r.moveEnd("character", o.value.length);
      if (r.text == "") return o.value.length;
      return Math.max(0, o.value.lastIndexOf(r.text));
    } else {
      try {
        return o.selectionStart;
      } catch (e) {
        return 0;
      }
    }
  };
  $.fn.getSelectionEnd = function (o) {
    if (o.type === "number") {
      return undefined;
    } else if (o.createTextRange && document.selection) {
      var r = document.selection.createRange().duplicate();
      r.moveStart("character", -o.value.length);
      return r.text.length;
    } else return o.selectionEnd;
  };
  $.fn.setSelection = function (o, p) {
    if (typeof p == "number") {
      p = [p, p];
    }
    if (p && p.constructor == Array && p.length == 2) {
      if (o.type === "number") {
        o.focus();
      } else if (o.createTextRange) {
        var r = o.createTextRange();
        r.collapse(true);
        r.moveStart("character", p[0]);
        r.moveEnd("character", p[1] - p[0]);
        r.select();
      } else {
        o.focus();
        try {
          if (o.setSelectionRange) {
            o.setSelectionRange(p[0], p[1]);
          }
        } catch (e) {}
      }
    }
  };
});

/*! jquery.cookie v1.4.1 | MIT */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? a(require("jquery"))
    : a(jQuery);
})(function (a) {
  function b(a) {
    return h.raw ? a : encodeURIComponent(a);
  }
  function c(a) {
    return h.raw ? a : decodeURIComponent(a);
  }
  function d(a) {
    return b(h.json ? JSON.stringify(a) : String(a));
  }
  function e(a) {
    0 === a.indexOf('"') &&
      (a = a.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
    try {
      return (
        (a = decodeURIComponent(a.replace(g, " "))), h.json ? JSON.parse(a) : a
      );
    } catch (b) {}
  }
  function f(b, c) {
    var d = h.raw ? b : e(b);
    return a.isFunction(c) ? c(d) : d;
  }
  var g = /\+/g,
    h = (a.cookie = function (e, g, i) {
      if (void 0 !== g && !a.isFunction(g)) {
        if (((i = a.extend({}, h.defaults, i)), "number" == typeof i.expires)) {
          var j = i.expires,
            k = (i.expires = new Date());
          k.setTime(+k + 864e5 * j);
        }
        return (document.cookie = [
          b(e),
          "=",
          d(g),
          i.expires ? "; expires=" + i.expires.toUTCString() : "",
          i.path ? "; path=" + i.path : "",
          i.domain ? "; domain=" + i.domain : "",
          i.secure ? "; secure" : "",
        ].join(""));
      }
      for (
        var l = e ? void 0 : {},
          m = document.cookie ? document.cookie.split("; ") : [],
          n = 0,
          o = m.length;
        o > n;
        n++
      ) {
        var p = m[n].split("="),
          q = c(p.shift()),
          r = p.join("=");
        if (e && e === q) {
          l = f(r, g);
          break;
        }
        e || void 0 === (r = f(r)) || (l[q] = r);
      }
      return l;
    });
  (h.defaults = {}),
    (a.removeCookie = function (b, c) {
      return void 0 === a.cookie(b)
        ? !1
        : (a.cookie(b, "", a.extend({}, c, { expires: -1 })), !a.cookie(b));
    });
});

/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === "function" && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === "object") {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = (window.Cookies = factory());
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
})(function () {
  function extend() {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[i];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init(converter) {
    function api(key, value, attributes) {
      var result;
      if (typeof document === "undefined") {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend(
          {
            path: "/",
          },
          api.defaults,
          attributes
        );

        if (typeof attributes.expires === "number") {
          var expires = new Date();
          expires.setMilliseconds(
            expires.getMilliseconds() + attributes.expires * 864e5
          );
          attributes.expires = expires;
        }

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        if (!converter.write) {
          value = encodeURIComponent(String(value)).replace(
            /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
            decodeURIComponent
          );
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        return (document.cookie = [
          key,
          "=",
          value,
          attributes.expires
            ? "; expires=" + attributes.expires.toUTCString()
            : "", // use expires attribute, max-age is not supported by IE
          attributes.path ? "; path=" + attributes.path : "",
          attributes.domain ? "; domain=" + attributes.domain : "",
          attributes.secure ? "; secure" : "",
        ].join(""));
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split("; ") : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split("=");
        var cookie = parts.slice(1).join("=");

        if (cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read
            ? converter.read(cookie, name)
            : converter(cookie, name) ||
              cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) {}
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) {}
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply(
        {
          json: true,
        },
        [].slice.call(arguments)
      );
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(
        key,
        "",
        extend(attributes, {
          expires: -1,
        })
      );
    };

    api.withConverter = init;

    return api;
  }

  return init(function () {});
});

/*
    A simple jQuery modal (http://github.com/kylefox/jquery-modal)
    Version 0.9.1
*/
!(function (o) {
  "object" == typeof module && "object" == typeof module.exports
    ? o(require("jquery"), window, document)
    : o(jQuery, window, document);
})(function (o, t, i, e) {
  var s = [],
    l = function () {
      return s.length ? s[s.length - 1] : null;
    },
    n = function () {
      var o,
        t = !1;
      for (o = s.length - 1; o >= 0; o--)
        s[o].$blocker &&
          (s[o].$blocker.toggleClass("current", !t).toggleClass("behind", t),
          (t = !0));
    };
  (o.modal = function (t, i) {
    var e, n;
    if (
      ((this.$body = o("body")),
      (this.options = o.extend({}, o.modal.defaults, i)),
      (this.options.doFade = !isNaN(parseInt(this.options.fadeDuration, 10))),
      (this.$blocker = null),
      this.options.closeExisting)
    )
      for (; o.modal.isActive(); ) o.modal.close();
    if ((s.push(this), t.is("a")))
      if (((n = t.attr("href")), (this.anchor = t), /^#/.test(n))) {
        if (((this.$elm = o(n)), 1 !== this.$elm.length)) return null;
        this.$body.append(this.$elm), this.open();
      } else
        (this.$elm = o("<div>")),
          this.$body.append(this.$elm),
          (e = function (o, t) {
            t.elm.remove();
          }),
          this.showSpinner(),
          t.trigger(o.modal.AJAX_SEND),
          o
            .get(n)
            .done(function (i) {
              if (o.modal.isActive()) {
                t.trigger(o.modal.AJAX_SUCCESS);
                var s = l();
                s.$elm.empty().append(i).on(o.modal.CLOSE, e),
                  s.hideSpinner(),
                  s.open(),
                  t.trigger(o.modal.AJAX_COMPLETE);
              }
            })
            .fail(function () {
              t.trigger(o.modal.AJAX_FAIL);
              var i = l();
              i.hideSpinner(), s.pop(), t.trigger(o.modal.AJAX_COMPLETE);
            });
    else
      (this.$elm = t),
        (this.anchor = t),
        this.$body.append(this.$elm),
        this.open();
  }),
    (o.modal.prototype = {
      constructor: o.modal,
      open: function () {
        var t = this;
        this.block(),
          this.anchor.blur(),
          this.options.doFade
            ? setTimeout(function () {
                t.show();
              }, this.options.fadeDuration * this.options.fadeDelay)
            : this.show(),
          o(i)
            .off("keydown.modal")
            .on("keydown.modal", function (o) {
              var t = l();
              27 === o.which && t.options.escapeClose && t.close();
            }),
          this.options.clickClose &&
            this.$blocker.click(function (t) {
              t.target === this && o.modal.close();
            });
      },
      close: function () {
        s.pop(),
          this.unblock(),
          this.hide(),
          o.modal.isActive() || o(i).off("keydown.modal");
      },
      block: function () {
        this.$elm.trigger(o.modal.BEFORE_BLOCK, [this._ctx()]),
          this.$body.css("overflow", "hidden"),
          (this.$blocker = o(
            '<div class="' +
              this.options.blockerClass +
              ' blocker current"></div>'
          ).appendTo(this.$body)),
          n(),
          this.options.doFade &&
            this.$blocker
              .css("opacity", 0)
              .animate({ opacity: 1 }, this.options.fadeDuration),
          this.$elm.trigger(o.modal.BLOCK, [this._ctx()]);
      },
      unblock: function (t) {
        !t && this.options.doFade
          ? this.$blocker.fadeOut(
              this.options.fadeDuration,
              this.unblock.bind(this, !0)
            )
          : (this.$blocker.children().appendTo(this.$body),
            this.$blocker.remove(),
            (this.$blocker = null),
            n(),
            o.modal.isActive() || this.$body.css("overflow", ""));
      },
      show: function () {
        this.$elm.trigger(o.modal.BEFORE_OPEN, [this._ctx()]),
          this.options.showClose &&
            ((this.closeButton = o(
              '<a href="#close-modal" rel="modal:close" class="close-modal ' +
                this.options.closeClass +
                '">' +
                this.options.closeText +
                "</a>"
            )),
            this.$elm.append(this.closeButton)),
          this.$elm.addClass(this.options.modalClass).appendTo(this.$blocker),
          this.options.doFade
            ? this.$elm
                .css({ opacity: 0, display: "inline-block" })
                .animate({ opacity: 1 }, this.options.fadeDuration)
            : this.$elm.css("display", "inline-block"),
          this.$elm.trigger(o.modal.OPEN, [this._ctx()]);
      },
      hide: function () {
        this.$elm.trigger(o.modal.BEFORE_CLOSE, [this._ctx()]),
          this.closeButton && this.closeButton.remove();
        var t = this;
        this.options.doFade
          ? this.$elm.fadeOut(this.options.fadeDuration, function () {
              t.$elm.trigger(o.modal.AFTER_CLOSE, [t._ctx()]);
            })
          : this.$elm.hide(0, function () {
              t.$elm.trigger(o.modal.AFTER_CLOSE, [t._ctx()]);
            }),
          this.$elm.trigger(o.modal.CLOSE, [this._ctx()]);
      },
      showSpinner: function () {
        this.options.showSpinner &&
          ((this.spinner =
            this.spinner ||
            o(
              '<div class="' + this.options.modalClass + '-spinner"></div>'
            ).append(this.options.spinnerHtml)),
          this.$body.append(this.spinner),
          this.spinner.show());
      },
      hideSpinner: function () {
        this.spinner && this.spinner.remove();
      },
      _ctx: function () {
        return {
          elm: this.$elm,
          $elm: this.$elm,
          $blocker: this.$blocker,
          options: this.options,
        };
      },
    }),
    (o.modal.close = function (t) {
      if (o.modal.isActive()) {
        t && t.preventDefault();
        var i = l();
        return i.close(), i.$elm;
      }
    }),
    (o.modal.isActive = function () {
      return s.length > 0;
    }),
    (o.modal.getCurrent = l),
    (o.modal.defaults = {
      closeExisting: !0,
      escapeClose: !0,
      clickClose: !0,
      closeText: "Close",
      closeClass: "",
      modalClass: "modal",
      blockerClass: "jquery-modal",
      spinnerHtml:
        '<div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div>',
      showSpinner: !0,
      showClose: !0,
      fadeDuration: null,
      fadeDelay: 1,
    }),
    (o.modal.BEFORE_BLOCK = "modal:before-block"),
    (o.modal.BLOCK = "modal:block"),
    (o.modal.BEFORE_OPEN = "modal:before-open"),
    (o.modal.OPEN = "modal:open"),
    (o.modal.BEFORE_CLOSE = "modal:before-close"),
    (o.modal.CLOSE = "modal:close"),
    (o.modal.AFTER_CLOSE = "modal:after-close"),
    (o.modal.AJAX_SEND = "modal:ajax:send"),
    (o.modal.AJAX_SUCCESS = "modal:ajax:success"),
    (o.modal.AJAX_FAIL = "modal:ajax:fail"),
    (o.modal.AJAX_COMPLETE = "modal:ajax:complete"),
    (o.fn.modal = function (t) {
      return 1 === this.length && new o.modal(this, t), this;
    }),
    o(i).on("click.modal", 'a[rel~="modal:close"]', o.modal.close),
    o(i).on("click.modal", 'a[rel~="modal:open"]', function (t) {
      t.preventDefault(), o(this).modal();
    });
});


/*
 * Refactor: Shop- und Kennzeichen-Logik
 * ------------------------------------------------------------
 * Die externen jQuery-Plugins oberhalb wurden bewusst unverändert gelassen.
 * Dieser Block ersetzt den früher global verteilten Shop-Code durch ein
 * gekapseltes Modul mit klaren Hilfsfunktionen, zentralen Selektoren und
 * robusten Guards gegen fehlende DOM-Elemente.
 */
(function ($, window, document) {
  "use strict";

  if (!$) {
    return;
  }

  /**
   * Zentrale Selektoren.
   * Vorteil: Änderungen an IDs/Klassen müssen später nur noch hier erfolgen.
   */
  var SELECTORS = {
    body: "body",

    platePreview: "#kz-preview",
    plateInputWrapper: "#kz-eingabe",
    plateDistrictInput: "#kz-e-kreis",
    plateLettersInput: "#kz-e-buchstaben",
    plateNumbersInput: "#kz-e-ziffern",
    platePreviewDistrict: "#kz-p-kreis",
    platePreviewLetters: "#kz-p-buchstaben",
    platePreviewNumbers: "#kz-p-ziffern",
    platePreviewSpecial: "#kz-p-sonderzeichen",
    plateWarning: ".kz-warnung",
    buyButtons: ".buy-buttons",

    seasonWrapper: "#kz-p-saison",
    seasonStartPreview: "#kz-p-saison-anfang",
    seasonEndPreview: "#kz-p-saison-ende",
    seasonStartOption: ".ymq-anfangsmonat",
    seasonEndOption: ".ymq-endmonat",

    ymqPlateInput: ".ymq-kennzeichen-eingabe input",
    ymqPlateTypeSelect: 'div[name="option-box-ymq-variant-Kennzeichenart"] select',
    ymqSizeSelect: 'div[name="option-box-ymq-variant-Größe"] select',
    ymqStartMonthSelect: ".ymq-anfangsmonat select",
    ymqEndMonthSelect: ".ymq-endmonat select",

    cartOverlay: "#cartbtn-overlay",
    inputCheckNotice: "#kzInputCheckHinweis",
    submitButton: 'button[type="submit"]',

    reservationNotice: "#kzHinweis",
    reservationLinkPrefix: "#kzReservierungLink",
    reservationRadioPrefix: "#kzReservierungRadio",
    reservationRadioLabelPrefix: "#kzReservierungRadioLabel",
    reservationRadioGroup: ".zulassungsbezirk-auswahl input:radio",
    reservationDistrictInput: ".zulassungsbezirk input",

    ePlateButton: "#e-kennzeichen-btn",
    hPlateButton: "#h-kennzeichen-btn",

    parkingInput: ".ymq-parkplatzkz-eingabe input",
    parkingPreview: "#parkplatz-kz-preview",
    parkingSourceInput: "#parkplatz-kz",
    hiddenLicenseInput: ".kennzeichen-eingabe input",

    holderTextInput: "#kzhalter-text",
    holderHiddenInput: ".ihr-text input",

    districtCookieInput: ".kz-preview-input"
  };

  /**
   * Laufender Zustand der Kennzeichen-Vorschau.
   * Die alten globalen Variablen werden zusätzlich synchronisiert, damit
   * vorhandene Inline-Skripte nicht brechen.
   */
  var state = {
    kzLength: 0,
    maxLength: 8,
    zeilezweiLength: 0,
    maxLengthZeileZwei: 7,
    zeileeinsLength: 0,
    maxLengthZeileEins: 3,
    zusatzzeichen: "",
    debug: false
  };

  /**
   * Größenlogik der Kennzeichen-Vorschau.
   * Jede Größe setzt CSS-Klasse und erlaubte Zeichenlängen.
   */
  var SIZE_PRESETS = [
    { match: "520 x 110", cssClass: "kz-520x110", max: 8, maxSecond: 7, maxFirst: 4 },
    { match: "480 x 110", cssClass: "kz-480x110", max: 6, maxSecond: 6, maxFirst: 4 },
    { match: "460 x 110", cssClass: "kz-460x110", max: 6, maxSecond: 7, maxFirst: 4 },
    { match: "440 x 110", cssClass: "kz-440x110", max: 5, maxSecond: 6, maxFirst: 4 },
    { match: "420 x 110", cssClass: "kz-420x110", max: 4, maxSecond: 5, maxFirst: 4 },
    { match: "400 x 110", cssClass: "kz-400x110", max: 4, maxSecond: 6, maxFirst: 4 },
    { match: "380 x 110", cssClass: "kz-380x110", max: 4, maxSecond: 6, maxFirst: 4 },
    { match: "360 x 110", cssClass: "kz-360x110", max: 4, maxSecond: 6, maxFirst: 4 },
    { match: "340 x 110", cssClass: "kz-340x110", max: 3, maxSecond: 6, maxFirst: 4 },
    { match: "340 x 200", cssClass: "kz-340x200 zweizeiler", max: 9, maxSecond: 6, maxFirst: 4 },
    { match: "320 x 200", cssClass: "kz-320x200 zweizeiler", max: 9, maxSecond: 5, maxFirst: 3 },
    { match: "300 x 200", cssClass: "kz-300x200 zweizeiler", max: 9, maxSecond: 5, maxFirst: 3 },
    { match: "280 x 200", cssClass: "kz-280x200 zweizeiler", max: 8, maxSecond: 4, maxFirst: 3 },
    { match: "260 x 200", cssClass: "kz-260x200 zweizeiler", max: 8, maxSecond: 4, maxFirst: 2 },
    { match: "250 x 200", cssClass: "kz-250x200 zweizeiler", max: 8, maxSecond: 4, maxFirst: 2 },
    { match: "240 x 200", cssClass: "kz-240x200 zweizeiler", max: 8, maxSecond: 3, maxFirst: 2, seasonMaxFirst: 1 },
    { match: "255 x 130", cssClass: "kz-255 zweizeiler", max: 8, maxSecond: 6, maxFirst: 3, seasonMax: 7 },
    { match: "240 x 130", cssClass: "kz-240 zweizeiler", max: 7, maxSecond: 5, maxFirst: 3, seasonMax: 6 },
    { match: "180 x 200", cssClass: "kz-180 zweizeiler", max: 7, maxSecond: 4, maxFirst: 3 },
    { match: "200 x 200", cssClass: "kz-200x200 zweizeiler", max: 7, maxSecond: 4, maxFirst: 3 },
    { match: "220 x 200", cssClass: "kz-220x200 zweizeiler", max: 8, maxSecond: 5, maxFirst: 3 }
  ];

  /**
   * Zulassungsbezirk-Daten.
   * Aus dem alten switch/case-Block erzeugt. Im Original war "MZ" doppelt
   * vorhanden; wie bei switch/case gilt hier der erste Treffer.
   */
  var RESERVATION_DATA = {
  "A": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Augsburg",
        "url": "http://www.augsburg.de/buergerservice-rathaus/buergerservice/dienste-a-z/aemterweise/leistungen-buergeramt-kfz-wesen/kfz-wunschkennzeichen/"
      }
    ]
  },
  "AA": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ostalbkreis",
        "url": "https://www.ostalbkreis.de/sixcms/detail.php?_topnav=69&_sub1=260526&_sub2=-1&id=1432"
      }
    ]
  },
  "AB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Aschaffenburg ",
        "url": "https://www.buergerserviceportal.de/bayern/aschaffenburg/igvwkz"
      },
      {
        "district": "Landkreis Aschaffenburg",
        "url": "https://www.buergerserviceportal.de/bayern/lkraschaffenburg/igvwkz"
      }
    ]
  },
  "ABG": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Altenburger Land",
        "url": "https://www.altenburgerland.de/de/buergerservice-online/wunschkennzeichen"
      }
    ]
  },
  "ABI": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Anhalt-Bitterfeld",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=anhalt-bitterfeld_kreis"
      }
    ]
  },
  "AC": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Städteregion Aachen",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=aachen_staedteregion_default"
      }
    ]
  },
  "AE": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Vogtlandkreis",
        "url": "https://kfz.vogtlandkreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=VOGTLANDKREISWKZ"
      }
    ]
  },
  "AH": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Borken",
        "url": "https://kreis-borken.de/de/service/themen/auto-verkehr/auto-verkehr/dienstleistungen-aufgaben/wunschkennzeichen/"
      }
    ]
  },
  "AIB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis München",
        "url": "https://www.buergerserviceportal.de/bayern/lkrmuenchen/igvwkz"
      },
      {
        "district": "Landkreis Rosenheim",
        "url": "https://www.landkreis-rosenheim.de/e-services/#tab-kennzeichenreservierung"
      }
    ]
  },
  "AIC": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Aichach-Friedberg",
        "url": "https://lra-aic-fdb.de/service/online-dienste/zulassungsvorgaenge-online/"
      }
    ]
  },
  "AK": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Altenkirchen (Westerwald)",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "ALF": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hildesheim",
        "url": "https://www.landkreishildesheim.de/B%C3%BCrgerservice/B%C3%BCrgerservice/KFZ-Zulassung/index.php?La=1&object=tx,1905.327.1&kat=&kuo=2&sub=0&NavID=1905.379"
      }
    ]
  },
  "ALZ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Aschaffenburg",
        "url": "https://www.buergerserviceportal.de/bayern/lkraschaffenburg/igvwkz"
      }
    ]
  },
  "AM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Amberg",
        "url": "https://www.buergerserviceportal.de/bayern/amberg/igvwkz"
      }
    ]
  },
  "AN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Ansbach",
        "url": "http://kfz.ansbach.eu/ekolwkz/index.jsp"
      },
      {
        "district": "Landkreis Ansbach",
        "url": "https://www.landkreis-ansbach.de/B-rgerservice/Wunschkennzeichen"
      }
    ]
  },
  "ANA": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "ANG": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uckermark",
        "url": "https://service.uckermark.de/wkz/"
      }
    ]
  },
  "ANK": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://www.kreis-vg.de/Landkreis/Wunschkennzeichen"
      }
    ]
  },
  "AÖ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Altötting",
        "url": "https://www.buergerserviceportal.de/bayern/lkraltoetting/igvwkz"
      }
    ]
  },
  "AP": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weimarer Land",
        "url": "https://ekol.lecos.de/wkz/?LICENSEIDENTIFIER=weimarer-land_kreis"
      }
    ]
  },
  "APD": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weimarer Land",
        "url": "https://ekol.lecos.de/wkz/?LICENSEIDENTIFIER=weimarer-land_kreis"
      }
    ]
  },
  "ARN": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Ilm-Kreis",
        "url": "http://www.ilm-kreis.de/index.phtml?mNavID=1626.184&sNavID=1626.184&La=1"
      }
    ]
  },
  "ART": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Kyffhäuserkreis",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=kyffhaeuserkreis_kreis"
      }
    ]
  },
  "AS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Amberg-Sulzbach",
        "url": "https://www.buergerserviceportal.de/bayern/lkrambergsulzbach/igvwkz"
      }
    ]
  },
  "ASL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Salzlandkreis",
        "url": "https://kfz.kreis-slk.de/wkz/controller"
      }
    ]
  },
  "ASZ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "AT": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "AU": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "AUR": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Aurich",
        "url": "https://www.landkreis-aurich.de/ordnung-veterinaer/ordnungswesen/verkehrswesen/wunschkennzeichen-online-services.html"
      }
    ]
  },
  "AW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ahrweiler",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "AZ": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Alzey-Worms",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "AZE": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Anhalt-Bitterfeld",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=anhalt-bitterfeld_kreis"
      }
    ]
  },
  "B": {
    "state": "Berlin",
    "hint": "",
    "links": [
      {
        "district": "Stadt Berlin",
        "url": "https://kfz-portal.berlin.de/"
      }
    ]
  },
  "BA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bamberg",
        "url": "https://www.buergerserviceportal.de/bayern/bamberg/igvwkz"
      },
      {
        "district": "Landkreis Bamberg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrbamberg/igvwkz"
      }
    ]
  },
  "BAD": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Baden-Baden",
        "url": "https://www.baden-baden.de/buergerservice/fahrzeuge/kennzeichen/wunschkennzeichen/"
      }
    ]
  },
  "BAR": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Barnim",
        "url": "https://www.barnim.de/verwaltung-politik/online-dienste-der-verwaltung/wunschkennzeichen.html"
      }
    ]
  },
  "BB": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Böblingen",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=BBL"
      }
    ]
  },
  "BBG": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Salzlandkreis",
        "url": "https://kfz.kreis-slk.de/wkz/controller"
      }
    ]
  },
  "BC": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Biberach",
        "url": "https://www.biberach.de/landratsamt/verkehrsamt/zulassungbehoerde/wunschkennzeichen.html"
      }
    ]
  },
  "BCH": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Neckar-Odenwald-Kreis",
        "url": "https://www.neckar-odenwald-kreis.de/Landratsamt/Verwaltung/Fachbereich+2+_+Umwelt_+Landentwicklung+und+Ordnungswesen/Ordnung+und+Verkehr/KFZ_Zulassung/Wunschkennzeichen.html"
      }
    ]
  },
  "BE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Warendorf",
        "url": "https://www.kreis-warendorf.de/kfz/wkz/"
      }
    ]
  },
  "BED": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV"
      }
    ]
  },
  "BER": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Barnim",
        "url": "https://www.barnim.de/verwaltung-politik/online-dienste-der-verwaltung/wunschkennzeichen"
      }
    ]
  },
  "BF": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Steinfurt",
        "url": "https://www.kreis-steinfurt.de/kv_steinfurt/Kreisverwaltung/%C3%84mter/Stra%C3%9Fenverkehrsamt/Zulassungsstelle/Aufgaben%20&%20Dienstleistungen/Wunschkennzeichen/"
      }
    ]
  },
  "BGD": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Berchtesgadener Land",
        "url": "https://kfz.lra-bgl.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "BGL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Berchtesgadener Land",
        "url": "https://kfz.lra-bgl.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "BH": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rastatt",
        "url": "https://www.landkreis-rastatt.de/landratsamt/aemteruebersicht/strassenverkehrsamt/auto-fuehrerschein-und-co"
      },
      {
        "district": "Ortenaukreis",
        "url": "https://www.ortenaukreis.de/Dienstleistungen/Verkehr/KFZ-Zulassung/Wunschkennzeichen-beantragen-oder-reservieren.php?object=tx,3406.2.1&ModID=10&FID=3406.263.1&kuo=2"
      }
    ]
  },
  "BI": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bielefeld",
        "url": "https://service.bielefeld.de/detail/-/vr-bis-detail/dienstleistung/8516/show"
      }
    ]
  },
  "BID": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Marburg-Biedenkopf",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.534000"
      }
    ]
  },
  "BIN": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mainz-Bingen",
        "url": "https://www.mainz-bingen.de/de/Aemter-Abteilungen/wirtschaft-verkehr/Kfz-Zulassung/Kennzeichen.php"
      }
    ]
  },
  "BIR": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Birkenfeld",
        "url": "https://www.landkreis-birkenfeld.de/Auto.htm/Dienstleistungen/Kfz-Onlinezulassung.html?keyword=5668"
      }
    ]
  },
  "BIT": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Eifelkreis Bitburg-Prüm",
        "url": "https://www.bitburg-pruem.de/cms/buergerservice-verwaltung/kfz-wunschkennzeichen"
      }
    ]
  },
  "BIW": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bautzen",
        "url": "https://www.landkreis-bautzen.de/kfz-kennzeichen.php"
      }
    ]
  },
  "BK": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Rems-Murr-Kreis",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WNL"
      },
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "BKS": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bernkastel-Wittlich",
        "url": "https://www.bernkastel-wittlich.de/kreisverwaltung/fachbereiche/verkehr-und-zulassung/zulassung-und-abmeldung-von-fahrzeugen/kennzeichenarten/#:~:text=Die%20Zuteilung%20eines%20Wunschkennzeichens%20kostet,Zulassung%20des%20Fahrzeugs%20zu%20entrichten."
      }
    ]
  },
  "BL": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Zollernalbkreis",
        "url": "https://www.zollernalbkreis.de/landratsamt/aemter++und+organisation/wunschkennzeichen"
      }
    ]
  },
  "BLB": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Siegen-Wittgenstein",
        "url": "https://www.siegen.de/ols/dienstleistungen-a-bis-z/aufgabe/wunschkennzeichen-kfz-wunschkennzeichenreservierung-200/"
      }
    ]
  },
  "BLK": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "BM": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Erft-Kreis",
        "url": "https://www.rhein-erft-kreis.de/36stra%C3%9Fenverkehrzulassung/dienstleistung/wunschkennzeichenreservieren"
      }
    ]
  },
  "BN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bonn",
        "url": "https://www.bonn.de/vv/produkte/Kfz-Wunschkennzeichen.php?cg_at_id=0"
      }
    ]
  },
  "BNA": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leipzig",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "BO": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bochum",
        "url": "https://www.bochum.de/Buero-fuer-Kfz-Angelegenheiten/Dienstleistungen-und-Infos/Wunschkennzeichen"
      }
    ]
  },
  "BÖ": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "BOG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Straubing-Bogen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrstraubingbogen/igvwkz"
      }
    ]
  },
  "BOH": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Borken",
        "url": "https://kreis-borken.de/de/service/themen/auto-verkehr/auto-verkehr/dienstleistungen-aufgaben/wunschkennzeichen/"
      }
    ]
  },
  "BOR": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Borken",
        "url": "https://kreis-borken.de/de/service/themen/auto-verkehr/auto-verkehr/dienstleistungen-aufgaben/zulassung/wunschkennzeichen/"
      }
    ]
  },
  "BOT": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bottrop",
        "url": "https://www.bottrop.de/rathaus/Online_Service/wunschkennzeichen.php"
      }
    ]
  },
  "BRA": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wesermarsch",
        "url": "https://wunschkennzeichen.kdo.de/kreisschluessel/03461"
      }
    ]
  },
  "BRB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Brandenburg an der Havel",
        "url": "https://www2.stadt-brandenburg.de/wkz/"
      }
    ]
  },
  "BRG": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Jerichower Land",
        "url": "https://kfz.lkjl.de/wkz/"
      }
    ]
  },
  "BRK": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Kissingen",
        "url": "https://www.landkreis-badkissingen.de/buerger--politik/buergerservice/fachbereiche-und-abteilungen/mobilitaet--verkehr/auto--verkehr/kfz-zulassung/reservierung-eines-kennzeichens-wunschkennzeichen/761.Reservierung-eines-Kennzeichens-Wunschkennzeichen.html"
      }
    ]
  },
  "BRL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Goslar",
        "url": "https://www.landkreis-goslar.de/index.phtml?La=1&sNavID=1749.116&mNavID=1749.116&object=tx|1749.2117.1&kat=&kuo=1&sub=0"
      }
    ]
  },
  "BRV": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rotenburg (Wümme)",
        "url": "https://www.lk-row.de/portal/seiten/wunschkennzeichen-1409-23700.html"
      }
    ]
  },
  "BS": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Braunschweig ",
        "url": "https://www.braunschweig.de/digitalisierung-online-services/online-services/wunschkennzeichen.php"
      }
    ]
  },
  "BSK": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oder-Spree",
        "url": "https://www.landkreis-oder-spree.de/Politik-Landkreis/Kreisverwaltung/%C3%84mter/Kraftfahrzeugkennzeichen-Reservierung-Wunschkennzeichen.php?object=tx,3410.2&ModID=10&FID=2426.283.1&NavID=2426.15&La=1#:~:text=Seit%20dem%204.%20Oktober%202022,Sicherheitsbestimmungen%20des%20Kraftfahrt%2DBundesamtes%20entsprach."
      }
    ]
  },
  "BT": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bayreuth",
        "url": "https://www.buergerserviceportal.de/bayern/bayreuth/igvwkz"
      },
      {
        "district": "Landkreis Bayreuth",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      }
    ]
  },
  "BTF": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Anhalt-Bitterfeld",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=anhalt-bitterfeld_kreis"
      }
    ]
  },
  "BÜD": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Wetteraukreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.440000"
      }
    ]
  },
  "BUL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Amberg-Sulzbach ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrambergsulzbach/igvwkz"
      },
      {
        "district": "Landkreis Schwandorf ",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "BÜR": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Paderborn",
        "url": "https://ekol.kreis-paderborn.de/wkz/"
      }
    ]
  },
  "BÜS": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Konstanz",
        "url": "https://www.buesingen.de/de/Rathaus/Buergerservice-A-Z/Buergerservice/Lebenslage?id=768&item=situation&view=publish"
      }
    ]
  },
  "BÜZ": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://wkz.lkros.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "BZ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bautzen",
        "url": "https://www.landkreis-bautzen.de/kfz-kennzeichen.php"
      }
    ]
  },
  "C": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Chemnitz",
        "url": "https://www-01.stadt-chemnitz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=C-WKZ"
      }
    ]
  },
  "CA": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oberspreewald-Lausitz",
        "url": "https://wkz.kreis-osl.de:4443/wkz/"
      }
    ]
  },
  "CAS": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Recklinghausen",
        "url": "https://www.kreis-re.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "CB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Cottbus",
        "url": "https://www.cottbus.de/abfrage/stadtbuero/vorgang.pl?id=3252"
      }
    ]
  },
  "CE": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Celle",
        "url": "https://www.landkreis-celle.de/index.php?ModID=7&FID=3314.16258.1&object=tx%7C3314.16258.1"
      }
    ]
  },
  "CHA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cham",
        "url": "https://www.landkreis-cham.de/service-beratung/kfz-zulassung/?WunschkennzeichenInternetzulassungAutokennzeichenreservierung&view=org&orgid=8b021403-8266-11d4-9694-0001020d335b"
      }
    ]
  },
  "CLP": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cloppenburg",
        "url": "https://lkclp.de/unser-landkre/ordnung--verkehr/kfz-zulassung/online-zulassungsbehoerde.php"
      }
    ]
  },
  "CLZ": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Goslar",
        "url": "https://www.landkreis-goslar.de/index.phtml?La=1&sNavID=1749.116&mNavID=1749.116&object=tx|1749.2117.1&kat=&kuo=1&sub=0"
      }
    ]
  },
  "CO": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Coburg und Landkreis Coburg",
        "url": "https://www.zulassungsstelle-coburg.de/portfolio-item/wunschkennzeichen/"
      }
    ]
  },
  "COC": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cochem-Zell",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "COE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Coesfeld",
        "url": "http://www.kreis-coesfeld.de/wkz/?LICENSEIDENTIFIER=coe"
      }
    ]
  },
  "CR": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schwäbisch Hall",
        "url": "https://www.lrasha.de/de/buergerservice/elektronische-dienste/wunschkennzeichen"
      }
    ]
  },
  "CUX": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cuxhaven",
        "url": "https://www.landkreis-cuxhaven.de/Themenbereiche/Verkehr/Wunschkennzeichen/"
      }
    ]
  },
  "CW": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Calw",
        "url": "https://www.kreis-calw.de/Service-Verwaltung/Verwaltung/Dezernate-und-Abteilungen/Dezernat-5-Infrastruktur-und-Ordnung/Ordnung-und-Verkehr/Wunschkennzeichen-beantragen-oder-reservieren.php?object=tx,2442.11.1&ModID=10&FID=2442.692.1&NavID=2442.116&La=1&ort="
      }
    ]
  },
  "D": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Düsseldorf",
        "url": "https://www.duesseldorf.de/kfz/online-services/wunschkennzeichen-reservierung.html"
      }
    ]
  },
  "DA": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Darmstadt",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.411000"
      },
      {
        "district": "Landkreis Darmstadt-Dieburg",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.432000"
      }
    ]
  },
  "DAH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dachau",
        "url": "http://wukz.landratsamt-dachau.de/vorfahrt-v510-wkz/servlet/Internetzulassungen?btn_wkz=start"
      }
    ]
  },
  "DAN": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lüchow-Dannenberg",
        "url": "https://wkz.luechow-dannenberg.de/wkz/?renderer=responsive"
      }
    ]
  },
  "DAU": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vulkaneifel",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "DBR": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://www.landkreis-rostock.de/de/zustaendigkeit-bau-undverkehrsamt/leistung/313/kfz-wunschkennzeichen_erstmalig_reservieren.html"
      }
    ]
  },
  "DD": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Dresden ",
        "url": "https://wunschkennzeichen.dresden.de/"
      }
    ]
  },
  "DE": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Stadt Dessau-Roßlau",
        "url": "https://verwaltung.dessau-rosslau.de/stadt-buerger/ordnung-und-verkehr/wunschkennzeichen.html"
      }
    ]
  },
  "DEG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Deggendorf",
        "url": "https://www.buergerserviceportal.de/bayern/lkrdeggendorf/igvwkz"
      }
    ]
  },
  "DEL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Delmenhorst",
        "url": "https://wkz.delmenhorst.de/"
      }
    ]
  },
  "DGF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dingolfing-Landau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrdingolfinglandau/igvwkz"
      }
    ]
  },
  "DH": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Diepholz",
        "url": "https://www.diepholz.de/buergerservice/dienstleistungen/wunschkennzeichen-462-0.html?myMedium=1"
      }
    ]
  },
  "DI": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Darmstadt-Dieburg",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.432000"
      }
    ]
  },
  "DIL": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Lahn-Dill-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.532000"
      }
    ]
  },
  "DIN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Wesel",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=WESEL"
      }
    ]
  },
  "DIZ": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Lahn-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "DKB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ansbach",
        "url": "https://www.landkreis-ansbach.de/B-rgerservice/Wunschkennzeichen"
      }
    ]
  },
  "DL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV&zbsbehoerde=15371"
      }
    ]
  },
  "DLG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dillingen an der Donau",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=dillingen_kreis"
      }
    ]
  },
  "DM": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "DN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Düren",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=dueren_kreis"
      }
    ]
  },
  "DO": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Dortmund",
        "url": "https://rathaus.dortmund.de/wps/portal/dortmund/home/dortmund/rathaus/domap/services.domap.de/product.services.domap.de/!ut/p/z1/jZDBTsMwDIafZYdca3djpeIWITSBqMQOa0suVbuaJlrrTmm6Ip6eAtoFQTZLPtj-_P-yQUEOisuTaUpnei7buX5VUbHcxssw3OAzrmWEMrm9T5NtivFuBdk3gP-ERFDX7HsA5ZfPQHktHtZ-YBOGfgBTvAAkNxeA6KzgueMJVNP21c_LJVeruAFl6Y0s2WC0c1s7dxzuBAqcpimoe-u6keugJoFf2VJFXBguzhOBJ7IH0nZeGHnY6wMxf5DZa2KBhmt6D7Tr_jTU_eAg_-UDx26Xo3k0L10WD3Kx-ASwAFJd/dz/d5/L2dBISEvZ0FBIS9nQSEh/?p_id=wunschkennzeichen0"
      }
    ]
  },
  "DON": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Donau-Ries",
        "url": "https://www.donau-ries.de/Buergerservice/Aufgabenbereiche/Zulassungsbehoerde.aspx?view=~/kxp/orgdata/default&orgid=c83424a6-8d7f-4cb0-a1f2-085565b28bb9"
      }
    ]
  },
  "DU": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Duisburg",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=DUISBURG"
      }
    ]
  },
  "DUD": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Göttingen ",
        "url": "https://www.landkreisgoettingen.de/themen-leistungen/verkehr-mobilitaet/kraftfahrzeuge/zulassungen-um-abmeldungen"
      }
    ]
  },
  "DÜW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Dürkheim",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "DW": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sächsische Schweiz-Osterzgebirge",
        "url": "https://dienste.landratsamt-pirna.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-PIRNA-WKZ"
      }
    ]
  },
  "DZ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://www.landkreis-nordsachsen.de/behoerdenwegweiser.html?m=tasks-detail&id=2626"
      }
    ]
  },
  "E": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Essen",
        "url": "https://wunschkennzeichen.essen.de/wkz/start"
      }
    ]
  },
  "EA": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Eisenach",
        "url": "https://www.eisenach.de/rathaus/aemter/ordnungsamt/kfz-zulassung"
      }
    ]
  },
  "EB": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://www.landkreis-nordsachsen.de/behoerdenwegweiser.html?m=tasks-detail&id=2626"
      }
    ]
  },
  "EBE": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ebersberg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrebersberg/igvwkz"
      }
    ]
  },
  "EBN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Haßberge",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhassberge/igvwkz"
      }
    ]
  },
  "EBS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bayreuth ",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      },
      {
        "district": "Landkreis Kulmbach ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkulmbach/igvwkz"
      },
      {
        "district": "Landkreis Forchheim ",
        "url": "https://www.lra-fo.de/site/2_aufgabenbereiche/Auto_Verkehr/Zulassungsstelle/wunschkennzeichen.php"
      }
    ]
  },
  "ECK": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Rendsburg-Eckernförde",
        "url": "https://www.kreis-rendsburg-eckernfoerde.de/bauen-mobilitaet/verkehr/kfz-zulassungsbehoerde/kennzeichenreservierung"
      }
    ]
  },
  "ED": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Erding",
        "url": "https://www.buergerserviceportal.de/bayern/lkrerding"
      }
    ]
  },
  "EE": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Elbe-Elster",
        "url": "https://ikfz.brandenburg.de/ikfz/de/kfz-zulassungsbehoerden/ee-elbe-elster/#Wunschkennzeichen%20ONLINE"
      }
    ]
  },
  "EF": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Erfurt",
        "url": "https://www.erfurt.de/ef/de/rathaus/bservice/leistungen/leistung-1755.htmc"
      }
    ]
  },
  "EG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rottal-Inn",
        "url": "https://www.buergerserviceportal.de/bayern/lkrrottalinn/igvwkz"
      }
    ]
  },
  "EH": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oder-Spree",
        "url": "https://www.landkreis-oder-spree.de/Politik-Landkreis/Kreisverwaltung/%C3%84mter/Kraftfahrzeugkennzeichen-Reservierung-Wunschkennzeichen.php?object=tx,3410.2&ModID=10&FID=2426.283.1&NavID=2426.15&La=1#:~:text=Seit%20dem%204.%20Oktober%202022,Sicherheitsbestimmungen%20des%20Kraftfahrt%2DBundesamtes%20entsprach."
      }
    ]
  },
  "EI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Eichstätt",
        "url": "http://195.243.195.253:8080/wkz/"
      }
    ]
  },
  "EIC": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Eichsfeld",
        "url": "https://www.kreis-eic.de/zulassung.html"
      }
    ]
  },
  "EIL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mansfeld-Südharz",
        "url": "https://ekol.mansfeldsuedharz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "EIN": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Northeim",
        "url": "https://www.landkreis-northeim.de/portal/seiten/wunschkennzeichen-reservieren-900000072-23900.html"
      }
    ]
  },
  "EIS": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Holzland-Kreis",
        "url": "https://www.saaleholzlandkreis.de/index.php?id=2256"
      }
    ]
  },
  "EL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Emsland",
        "url": "https://wunschkennzeichen.emsland.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=EL"
      }
    ]
  },
  "EM": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Emmendingen",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-em/servlet/Internetgeschaeftsvorfaelle?DIALOG=WKZ"
      }
    ]
  },
  "EMD": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Emden",
        "url": "https://wkz.emden.de/wkz/"
      }
    ]
  },
  "EMS": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Lahn-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "EN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Ennepe-Ruhr-Kreis",
        "url": "https://kfzwk.en-kreis.de/wkz/"
      }
    ]
  },
  "ER": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Erlangen",
        "url": "https://secure.erlangen.de/wkz/"
      }
    ]
  },
  "ERB": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Odenwaldkreis",
        "url": "https://www.odenwaldkreis.de/de/buergerservice-2/leistungen/HES:entry:8963394:06437/kfz-kennzeichen-wunschkennzeichen/"
      }
    ]
  },
  "ERH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Erlangen-Höchstadt",
        "url": "https://www.buergerserviceportal.de/bayern/lkrerlangenhoechstadt/igvwkz"
      }
    ]
  },
  "ERK": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Heinsberg",
        "url": "https://service.kreis-heinsberg.de/dienstleistungen-a-z/-/egov-bis-detail/dienstleistung/149458/show"
      }
    ]
  },
  "ERZ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "ES": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Esslingen",
        "url": "https://www.landkreis-esslingen.de/start/service/Wunschkennzeichen.html"
      }
    ]
  },
  "ESB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Amberg-Sulzbach ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrambergsulzbach/igvwkz"
      },
      {
        "district": "Landkreis Bayreuth ",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      },
      {
        "district": "Landkreis Neustadt an der Waldnaab",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneustadtwaldnaab/igvwkz"
      },
      {
        "district": "Landkreis Nürnberger Land",
        "url": "http://wunschkennzeichen.nuernberger-land.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "ESW": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Werra-Meißner-Kreis",
        "url": "https://www.werra-meissner-kreis.de/fachbereiche-einrichtungen/fb-3-aufsicht-ordnung-und-verkehr/35-strassenverkehrsbehoerde/kfz-zulassung"
      }
    ]
  },
  "EU": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Euskirchen",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=euskirchen_kreis"
      }
    ]
  },
  "EW": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Barnim",
        "url": "https://www.barnim.de/verwaltung-politik/online-dienste-der-verwaltung/wunschkennzeichen"
      }
    ]
  },
  "F": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Frankfurt am Main",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.412000"
      }
    ]
  },
  "FB": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Wetteraukreis",
        "url": "http://www.wetteraukreis.de/service/auto-verkehr/dienstleistungen-auto-und-verkehr/kfz-zulassung/wunschkennzeichen/"
      }
    ]
  },
  "FD": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Fulda",
        "url": "https://www.landkreis-fulda.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=FULDA-WKZ"
      }
    ]
  },
  "FDB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Aichach-Friedberg",
        "url": "https://www.buergerserviceportal.de/bayern/lkraichachfriedberg/igvwkz"
      }
    ]
  },
  "FDS": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freudenstadt",
        "url": "https://www.landkreis-freudenstadt.de/Startseite/Landratsamt/wunschkennzeichen.html"
      }
    ]
  },
  "FEU": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ansbach",
        "url": "https://www.landkreis-ansbach.de/B-rgerservice/Wunschkennzeichen"
      }
    ]
  },
  "FF": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Frankfurt (Oder)",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=frankfurt-oder_stadt"
      }
    ]
  },
  "FFB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Fürstenfeldbruck",
        "url": "https://www.buergerserviceportal.de/bayern/lkrfuerstenfeldbruck/igvwkz"
      }
    ]
  },
  "FG": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV&zbsbehoerde=15371"
      }
    ]
  },
  "FI": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Elbe-Elster",
        "url": "https://ikfz.brandenburg.de/ikfz/de/kfz-zulassungsbehoerden/ee-elbe-elster/#Wunschkennzeichen%20ONLINE"
      }
    ]
  },
  "FKB": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Waldeck-Frankenberg",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.635000"
      }
    ]
  },
  "FL": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Stadt Flensburg",
        "url": "https://wkz.kommunit.de/wkz/?LICENSEIDENTIFIER=fl"
      }
    ]
  },
  "FLÖ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV&zbsbehoerde=15371"
      }
    ]
  },
  "FN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Bodenseekreis",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=FNL"
      }
    ]
  },
  "FO": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Forchheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrforchheim/igvwkz?AUFRUF=WKZ"
      }
    ]
  },
  "FOR": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Spree-Neiße",
        "url": "https://wunschkennzeichen.lkspn.de/wkz/"
      }
    ]
  },
  "FR": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Freiburg im Breisgau",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-frs/servlet/Internetgeschaeftsvorfaelle?DIALOG=WKZ"
      },
      {
        "district": "Landkreis Breisgau-Hochschwarzwald",
        "url": "https://kfz.lkbh.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LKBH-WKZ"
      }
    ]
  },
  "FRG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freyung-Grafenau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrfreyunggrafenau/igvwkz"
      }
    ]
  },
  "FRI": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Friesland",
        "url": "https://www.friesland.de/portal/seiten/kfz-zulassungsstelle-wunschkennzeichen-901000392-20800.html"
      }
    ]
  },
  "FRW": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Märkisch-Oderland",
        "url": "https://www.landkreismol.de/wkz/"
      }
    ]
  },
  "FS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freising",
        "url": "https://www.buergerserviceportal.de/bayern/lkrfreising/igvwkz"
      },
      {
        "district": "Stadt Moosburg an der Isar",
        "url": "https://www.moosburg.de/kfz-zulassungsbehoerde"
      }
    ]
  },
  "FT": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Frankenthal (Pfalz)",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "FTL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sächsische Schweiz-Osterzgebirge",
        "url": "https://dienste.landratsamt-pirna.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-PIRNA-WKZ"
      }
    ]
  },
  "FÜ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Fürth ",
        "url": "https://www.landkreis-fuerth.de/zuhause-im-landkreis/verkehr/kfz-zulassung/wunschkennzeichen.html"
      },
      {
        "district": "Landkreis Fürth ",
        "url": "https://www.landkreis-fuerth.de/zuhause-im-landkreis/verkehr/kfz-zulassung/wunschkennzeichen.html"
      }
    ]
  },
  "FÜS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostallgäu",
        "url": "https://www.buergerserviceportal.de/bayern/ostallgaeu/igvwkz"
      }
    ]
  },
  "FW": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oder-Spree",
        "url": "https://www.landkreis-oder-spree.de/Politik-Landkreis/Kreisverwaltung/%C3%84mter/Kraftfahrzeugkennzeichen-Reservierung-Wunschkennzeichen.php?object=tx,3410.2&ModID=10&FID=2426.283.1&NavID=2426.15&La=1#:~:text=Seit%20dem%204.%20Oktober%202022,Sicherheitsbestimmungen%20des%20Kraftfahrt%2DBundesamtes%20entsprach."
      }
    ]
  },
  "FZ": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Schwalm-Eder-Kreis",
        "url": "https://www.schwalm-eder-kreis.de/Wunschkennzeichen.htm?"
      }
    ]
  },
  "G": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Gera",
        "url": "https://www.gera.de/sixcms/detail.php?id=24642"
      }
    ]
  },
  "GA": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Altmarkkreis Salzwedel",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=salzwedel_altmarkkreis&renderer=responsive"
      }
    ]
  },
  "GAN": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Northeim",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "GAP": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Garmisch-Partenkirchen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrgarmischpartenkirchen/igvwkz"
      }
    ]
  },
  "GC": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Zwickau",
        "url": "https://wunschkennzeichen.landkreis-zwickau.de/ekol-wkz-zl/"
      }
    ]
  },
  "GD": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ostalbkreis",
        "url": "https://www.ostalbkreis.de/sixcms/detail.php?_topnav=69&_sub1=260526&_sub2=-1&id=1432"
      }
    ]
  },
  "GDB": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordwestmecklenburg",
        "url": "http://www.nordwestmecklenburg.de/de/kfz-zulassung-detail/leistung/1112/kfz-kennzeichen_reservierung_wunschkennzeichen.html"
      }
    ]
  },
  "GE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Gelsenkirchen",
        "url": "https://www.gelsenkirchen.de/de/infrastruktur/verkehr/rund_ums_auto/kfz-zulassungsstelle/wunschkennzeichen.aspx"
      }
    ]
  },
  "GEL": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Kleve",
        "url": "https://www.kreis-kleve.de/de/dienstleistungen/wunschkennzeichen/"
      }
    ]
  },
  "GEO": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Haßberge ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhassberge/igvwkz"
      },
      {
        "district": "Landkreis Schweinfurt ",
        "url": "https://www.landkreis-schweinfurt.de/service-infos/serviceleistungen-informationen/serviceinfos/detail/wunschkennzeichen-1385"
      }
    ]
  },
  "GER": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Germersheim",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "GF": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Gifhorn",
        "url": "https://wkz.gifhorn.de/wkz/"
      }
    ]
  },
  "GG": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Groß-Gerau",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.433000"
      }
    ]
  },
  "GHA": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leipzig",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "GHC": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wittenberg",
        "url": "https://www.landkreis-wittenberg.de/de/wunschkennzeichen/kfz-online-20000419.html"
      }
    ]
  },
  "GI": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Gießen",
        "url": "https://www.lkgi.de/verkehr-sicherheit-und-ordnung/kfz-zulassungen/wunschkennzeichen2"
      }
    ]
  },
  "GK": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Heinsberg",
        "url": "https://service.kreis-heinsberg.de/dienstleistungen-a-z/-/egov-bis-detail/dienstleistung/149458/show"
      }
    ]
  },
  "GL": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Rheinisch-Bergischer Kreis",
        "url": "https://www.rbk-direkt.de/dienstleistung.aspx?dlid=300"
      }
    ]
  },
  "GLA": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Recklinghausen",
        "url": "https://www.kreis-re.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "GM": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Oberbergischer Kreis",
        "url": "http://obk.de/cms200/service/bis/onlineservices/151500/index.shtml"
      }
    ]
  },
  "GMN": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Rügen",
        "url": "https://www.lk-vr.de/Kreisverwaltung/Onlinedienste/Online-Wunschkennzeichen"
      }
    ]
  },
  "GN": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Main-Kinzig-Kreis ",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.435000"
      }
    ]
  },
  "GNT": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Jerichower Land",
        "url": "https://kfz.lkjl.de/wkz/"
      }
    ]
  },
  "GÖ": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Göttingen",
        "url": "https://www.landkreisgoettingen.de/staticsite/staticsite.php?menuid=83&topmenu=13"
      },
      {
        "district": "Stadt Göttingen ",
        "url": "https://www.goettingen.de/rathaus/service/dienstleistungen/wunschkennzeichen.html"
      }
    ]
  },
  "GOA": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Hunsrück-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "GOH": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Lahn-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "GP": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Göppingen",
        "url": "https://www.landkreis-goeppingen.de/start/Landratsamt/Wunschkennzeichen.html"
      }
    ]
  },
  "GR": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=852609&waid=392"
      }
    ]
  },
  "GRA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freyung-Grafenau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrfreyunggrafenau/igvwkz"
      }
    ]
  },
  "GRH": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Meißen",
        "url": "http://www.kreis-meissen.org/16853.html#a_16875"
      }
    ]
  },
  "GRI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rottal-Inn ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrrottalinn/igvwkz"
      }
    ]
  },
  "GRM": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leipzig",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "GRZ": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Greiz",
        "url": "https://www.landkreis-greiz.de/landkreis-greiz/organisatorisch/kreisverwaltung/redakteursebene-aemter/ordnungsamt/strassenverkehrsbehoerde/zulassung"
      }
    ]
  },
  "GS": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Goslar",
        "url": "https://formulare.landkreis-goslar.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "GT": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Gütersloh",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=guetersloh_kreis"
      }
    ]
  },
  "GTH": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Gotha",
        "url": "https://www.landkreis-gotha.de/service/kfz-zulassung/"
      }
    ]
  },
  "GÜ": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://www.landkreis-rostock.de/de/zustaendigkeit-bau-undverkehrsamt/leistung/313/kfz-wunschkennzeichen_erstmalig_reservieren.html"
      }
    ]
  },
  "GUB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Spree-Neiße",
        "url": "https://wunschkennzeichen.lkspn.de/wkz/"
      }
    ]
  },
  "GUN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weißenburg-Gunzenhausen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrweissenburggunzenhausen/igvwkz"
      }
    ]
  },
  "GV": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Kreis Neuss",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=NEUSS"
      }
    ]
  },
  "GVM": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordwestmecklenburg",
        "url": "http://www.nordwestmecklenburg.de/de/kfz-zulassung-detail/leistung/1112/kfz-kennzeichen_reservierung_wunschkennzeichen.html"
      }
    ]
  },
  "GW": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://www.kreis-vg.de/Landkreis/Wunschkennzeichen"
      }
    ]
  },
  "GZ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Günzburg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrguenzburg/igvwkz"
      }
    ]
  },
  "H": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Region Hannover",
        "url": "https://www.hannover.de/Leben-in-der-Region-Hannover/Mobilit%C3%A4t/Kraftfahrzeug-Stra%C3%9Fe/KFZ-Zulassung-in-Stadt-und-Region/Wunschkennzeichen%C2%ADreservierung"
      },
      {
        "district": "Stadt Hannover ",
        "url": "https://wunschkennzeichen.hannover-stadt.de/index.html#down"
      }
    ]
  },
  "HA": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Hagen",
        "url": "http://www.hagen.de/irj/portal/Wunschkennzeichen"
      }
    ]
  },
  "HAB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Kissingen",
        "url": "http://kfz.service-kg.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "HAL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Stadt Halle (Saale)",
        "url": "https://www.halle.de/de/Verwaltung/Online-Angebote/Online-Dienste/Wunschkennzeichen/Wunschkennzeichen-online/index.aspx"
      }
    ]
  },
  "HAM": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Hamm",
        "url": "https://www.hamm.de/wkz/?LICENSEIDENTIFIER=ham"
      }
    ]
  },
  "HAS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Haßberge",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhassberge/igvwkz"
      }
    ]
  },
  "HB": {
    "state": "Bremen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bremen",
        "url": "https://www.service.bremen.de/sixcms/detail.php?gsid=bremen128.c.18495.de&asl=bremen2014_sp.c.13092.de"
      },
      {
        "district": "Stadt Bremerhaven ",
        "url": "https://wunschkennzeichen.bremerhaven.de/wkz/"
      }
    ]
  },
  "HBN": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hildburghausen",
        "url": "https://www.landkreis-hildburghausen.de/Schnellnavigation/Wunschkennzeichen"
      }
    ]
  },
  "HBS": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Harz",
        "url": "http://www.kreis-hz.de/de/wunschkennzeichen.html"
      }
    ]
  },
  "HC": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV&zbsbehoerde=15371"
      }
    ]
  },
  "HCH": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Zollernalbkreis",
        "url": "https://www.zollernalbkreis.de/site/LRA-ZAK-2017/node/15331029?QUERYSTRING=wunschkennzeichen"
      }
    ]
  },
  "HD": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Heidelberg",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-man/servlet/Internetgeschaeftsvorfaelle?MANDANT=08221000&AUFRUF=WKZ"
      },
      {
        "district": "Rhein-Neckar-Kreis",
        "url": "https://www.rhein-neckar-kreis.de/start/service/wunschkennzeichen.html"
      }
    ]
  },
  "HDH": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Heidenheim",
        "url": "https://laikra.komm.one/dvvlaikraIGV21/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ_hdh"
      }
    ]
  },
  "HDL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "HE": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Helmstedt",
        "url": "https://www.helmstedt.de/verwaltung/dienstleistungen/dienstleistung.php?id=249&menuid=227"
      }
    ]
  },
  "HEB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nürnberger Land",
        "url": "http://wunschkennzeichen.nuernberger-land.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "HEF": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hersfeld-Rotenburg",
        "url": "https://www.hef-rof.de/landratsamt/kfz-verkehr/kfz-zulassung"
      }
    ]
  },
  "HEI": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Dithmarschen",
        "url": "https://www.dithmarschen.de/Service-nutzen/Kfz-Zulassung-und-F%C3%BChrerschein/Wunschkennzeichen"
      }
    ]
  },
  "HER": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Herne",
        "url": "https://wuke.herne.de/wkz/"
      }
    ]
  },
  "HET": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mansfeld-Südharz",
        "url": "https://ekol.mansfeldsuedharz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "HF": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Herford",
        "url": "https://www.buergerserviceportal.nrw/krz/lkrherford/igvwkz"
      }
    ]
  },
  "HG": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Hochtaunuskreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.434000"
      }
    ]
  },
  "HGN": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "HGW": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Greifswald",
        "url": "https://www.greifswald.de/de/verwaltung-politik/verwaltungsleistungen_basis/Kraftfahrzeugkennzeichen-Reservierung-erstmalig/"
      }
    ]
  },
  "HH": {
    "state": "Hamburg",
    "hint": "",
    "links": [
      {
        "district": "Freie und Hansestadt Hamburg",
        "url": "https://serviceportal.hamburg.de/HamburgGateway/Service/Entry/WUKENNZ"
      }
    ]
  },
  "HHM": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "HI": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hildesheim",
        "url": "https://www.landkreishildesheim.de/B%C3%BCrgerservice/Deep/KFZ-Zulassung/index.php?La=1&object=tx,1905.327.1&kat=&kuo=2&sub=0&NavID=2829.41"
      }
    ]
  },
  "HIG": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Eichsfeld",
        "url": "https://www.kreis-eic.de/zulassung.html"
      }
    ]
  },
  "HIP": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Roth",
        "url": "https://www.buergerserviceportal.de/bayern/lkrroth/igvwkz"
      }
    ]
  },
  "HK": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Heidekreis",
        "url": "https://egov3.heidekreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "HL": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Stadt Lübeck",
        "url": "https://www.luebeck.de/de/buergerservice/leistungen/?lid=8937787&zufi=1"
      }
    ]
  },
  "HM": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hameln-Pyrmont",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.03.252000"
      }
    ]
  },
  "HMÜ": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Göttingen",
        "url": "https://www.landkreisgoettingen.de/staticsite/staticsite.php?menuid=83&topmenu=13"
      }
    ]
  },
  "HN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Heilbronn / Stadt Heilbronn",
        "url": "https://www.landkreis-heilbronn.de/reservierung-eines-wunschkennzeichens.804.htm"
      }
    ]
  },
  "HO": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hof ",
        "url": "https://www.stadt-hof.org/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      },
      {
        "district": "Stadt Hof",
        "url": "https://www.stadt-hof.org/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "HOG": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kassel",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.611000"
      }
    ]
  },
  "HOH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Haßberge",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhassberge/igvwkz"
      }
    ]
  },
  "HOL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Holzminden",
        "url": "https://www.landkreis-holzminden.de/portal/seiten/kfz-zulassung-900000081-25600.html"
      }
    ]
  },
  "HOM": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Saarpfalz-Kreis",
        "url": "https://www.saarpfalz-kreis.de/kfz-zulassung/vorgaenge/wunschkennzeichen"
      }
    ]
  },
  "HOR": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freudenstadt",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-man/servlet/Internetgeschaeftsvorfaelle?MANDANT=08237000&AUFRUF=WKZ"
      }
    ]
  },
  "HÖS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Erlangen-Höchstadt",
        "url": "https://www.buergerserviceportal.de/bayern/lkrerlangenhoechstadt/igvwkz"
      }
    ]
  },
  "HOT": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Zwickau",
        "url": "https://wunschkennzeichen.landkreis-zwickau.de/ekol-wkz-zl/"
      }
    ]
  },
  "HP": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Bergstraße",
        "url": "http://wkz.kreis-bergstrasse.de/wkz/"
      }
    ]
  },
  "HR": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Schwalm-Eder-Kreis",
        "url": "https://www.schwalm-eder-kreis.de/Wunschkennzeichen.htm?"
      }
    ]
  },
  "HRO": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Rostock",
        "url": "https://dienste.rostock.de/wkz/"
      }
    ]
  },
  "HS": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Heinsberg",
        "url": "https://service.kreis-heinsberg.de/dienstleistungen-a-z?p_p_id=CookiePortlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_CookiePortlet_javax.portlet.action=%2Fcookies%2Fsaveall&p_auth=JdnZ705J"
      }
    ]
  },
  "HSK": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Hochsauerlandkreis",
        "url": "https://wunschkennzeichen.hochsauerlandkreis.de/"
      }
    ]
  },
  "HST": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Stralsund",
        "url": "https://wunschkennzeichen.stralsund.de/"
      }
    ]
  },
  "HU": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Hanau / Main-Kinzig-Kreis ",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.435000"
      }
    ]
  },
  "HV": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Stendal",
        "url": "https://www.landkreis-stendal.de/de/kfz-zulassung/internet-kfz-zulassung.html"
      }
    ]
  },
  "HVL": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Havelland",
        "url": "https://www.havelland.de/wirtschaft-verkehr/verkehr/kfz-zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "HWI": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Wismar",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=wismar_stadt&renderer=responsive"
      }
    ]
  },
  "HX": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Höxter",
        "url": "https://kfz.kreis-hoexter.de/wkz/"
      }
    ]
  },
  "HY": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bautzen",
        "url": "https://webservice.landkreis-bautzen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "HZ": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Harz",
        "url": "http://www.kreis-hz.de/de/wunschkennzeichen.html"
      }
    ]
  },
  "IGB": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Stadt St. Ingbert ",
        "url": "https://www.st-ingbert.de/rathaus/buergerservice-und-info/wunschkennzeichen.html"
      }
    ]
  },
  "IK": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Ilm-Kreis",
        "url": "https://www.ilm-kreis.de/%C3%84mter/Verkehrs-Gewerbe-und-Ordnungsamt/Wunschkennzeichen"
      }
    ]
  },
  "IL": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Ilm-Kreis",
        "url": "https://www.ilm-kreis.de/%C3%84mter/Verkehrs-Gewerbe-und-Ordnungsamt/Wunschkennzeichen"
      }
    ]
  },
  "ILL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neu-Ulm",
        "url": "https://www.lra-nu.de/wunschkennzeichen/index.jsp"
      }
    ]
  },
  "IN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Ingolstadt",
        "url": "https://www.buergerserviceportal.de/bayern/ingolstadt/igvwkz"
      }
    ]
  },
  "IZ": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Steinburg",
        "url": "https://service.steinburg.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "J": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Jena",
        "url": "https://service.jena.de/de/wunschkennzeichen-online-reservieren"
      }
    ]
  },
  "JE": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wittenberg",
        "url": "https://www.landkreis-wittenberg.de/de/wunschkennzeichen/kfz-online-20000419.html"
      }
    ]
  },
  "JL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Jerichower Land",
        "url": "https://kfz.lkjl.de/wkz/"
      }
    ]
  },
  "JÜL": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Düren",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=dueren_kreis"
      }
    ]
  },
  "K": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Köln",
        "url": "https://i-kfz.regioit.de/i4/ikfz4/?LICENSEIDENTIFIER=koeln_stadt"
      }
    ]
  },
  "KA": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Karlsruhe ",
        "url": "https://web1.karlsruhe.de/service/Buergerdienste/leistung.php?id=6002421"
      },
      {
        "district": "Landkreis Karlsruhe ",
        "url": "https://kfz2.virtuelles-rathaus.de/igv/servlet/Internetgeschaeftsvorfaelle?MANDANT=08215000&AUFRUF=WKZ"
      }
    ]
  },
  "KB": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Waldeck-Frankenberg",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.635000"
      }
    ]
  },
  "KC": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kronach",
        "url": "https://igv.osrz-akdb.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=09476_kro"
      }
    ]
  },
  "KE": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Kempten (Allgäu) ",
        "url": "https://www.buergerserviceportal.de/bayern/kempten/igvwkz"
      }
    ]
  },
  "KEH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kelheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkelheim/igvwkz"
      }
    ]
  },
  "KEL": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ortenaukreis",
        "url": "https://kfz2.virtuelles-rathaus.de/igv/servlet/Internetgeschaeftsvorfaelle?MANDANT=08317000&AUFRUF=WKZ"
      }
    ]
  },
  "KEM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bayreuth ",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      },
      {
        "district": "Landkreis Tirschenreuth ",
        "url": "https://www.kreis-tir.de/fachbereiche/strassen-verkehr-oepnv/auto-und-strassenverkehr/kfz-zulassung/wunschkennzeichen-online/"
      }
    ]
  },
  "KF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Kaufbeuren",
        "url": "https://wunschkennzeichen.kaufbeuren.de/wkz/"
      }
    ]
  },
  "KG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Kissingen",
        "url": "http://kfz.service-kg.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "KH": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Kreuznach",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "KI": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Stadt Kiel",
        "url": "https://www.kiel.de/de/politik_verwaltung/service/_leistung.php?id=8937787#:~:text=die%20zust%C3%A4ndige%20Beh%C3%B6rde.-,Hinweise%20f%C3%BCr%20Kiel%3A,Tage%20kostet%2010%2C00%20Euro."
      }
    ]
  },
  "KIB": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Donnersbergkreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "KK": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Viersen",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=VIERSEN"
      }
    ]
  },
  "KL": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Kaiserslautern ",
        "url": "https://kfzonline.ewois.de/"
      },
      {
        "district": "Landkreis Kaiserslautern",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "KLE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Kleve",
        "url": "https://www.kreis-kleve.de/de/dienstleistungen/wunschkennzeichen/"
      }
    ]
  },
  "KLZ": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Altmarkkreis Salzwedel",
        "url": "https://www.altmarkkreis-salzwedel.de/buerger-presseservice/buergerservice/was-wo-erledigen.aspx/oeid-341645539/anliegenid-11863438/"
      }
    ]
  },
  "KM": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bautzen",
        "url": "https://webservice.landkreis-bautzen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "KN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Konstanz",
        "url": "https://kfz2.virtuelles-rathaus.de/overview/"
      }
    ]
  },
  "KO": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Koblenz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "KÖN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rhön-Grabfeld",
        "url": "https://kfz.rhoen-grabfeld.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "KÖT": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Anhalt-Bitterfeld",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=anhalt-bitterfeld_kreis"
      }
    ]
  },
  "KÖZ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cham",
        "url": "https://wkz.landkreis-cham.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "KR": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Krefeld",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=KREFELD"
      }
    ]
  },
  "KRU": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Günzburg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrguenzburg/igvwkz"
      }
    ]
  },
  "KS": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Kassel",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.611000"
      },
      {
        "district": "Landkreis Kassel",
        "url": "https://www.kassel.de/service/produkte/kassel/Buergeramt/kfz-zulassung/wunschkennzeichen-fuer-fahrzeuge-online-reservieren.php#Online-Services"
      }
    ]
  },
  "KT": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kitzingen",
        "url": "https://public.kitzingen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "KU": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kulmbach",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkulmbach/igvwkz"
      }
    ]
  },
  "KÜN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Hohenlohekreis",
        "url": "https://www.hohenlohekreis.de/de/buergerservice/bereiche-von-a-z/kfz-zulassung/wunschkennzeichen"
      }
    ]
  },
  "KUS": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kusel",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "KW": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dahme-Spreewald",
        "url": "https://www.dahme-spreewald.info/de/verwaltung/verwaltungsstruktur/dezernat3/strassenverkehrsamt/zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "KY": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostprignitz-Ruppin",
        "url": "https://www.o-p-r.info/kfzwkz/"
      }
    ]
  },
  "KYF": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Kyffhäuserkreis",
        "url": "https://www.kyffhaeuser.de/service-verwaltung/aemter-organigramm/ordnungsverwaltung/fuehrerscheinstelle/"
      }
    ]
  },
  "L": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Leipzig",
        "url": "https://www.leipzig.de/fachanwendungen/kennzeichenreservierung/index.html"
      },
      {
        "district": "Landkreis Leipzig ",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "LA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Landshut",
        "url": "https://www.landshut.de/leben/strassenverkehrsamt/zulassungsbehoerde/wunschkennzeichen"
      },
      {
        "district": "Landkreis Landshut ",
        "url": "https://www.landkreis-landshut.de/themen/mobilitaet/kfz-zulassung/?Wunschkennzeichen&view=org&orgid=5e766cff-dcbf-4d80-bda6-b173eb0d7789"
      }
    ]
  },
  "LAN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dingolfing-Landau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrdingolfinglandau/igvwkz"
      }
    ]
  },
  "LAU": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nürnberger Land",
        "url": "http://wunschkennzeichen.nuernberger-land.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "LB": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigsburg",
        "url": "https://laikra.komm.one/dvvlaikraIGV21/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ_lbl"
      }
    ]
  },
  "LBS": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Orla-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.075000"
      }
    ]
  },
  "LBZ": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "LC": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dahme-Spreewald",
        "url": "https://www.dahme-spreewald.info/de/verwaltung/verwaltungsstruktur/dezernat3/strassenverkehrsamt/zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "LD": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Landau in der Pfalz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "LDK": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Lahn-Dill-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.532000"
      }
    ]
  },
  "LDS": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dahme-Spreewald",
        "url": "https://www.dahme-spreewald.info/de/verwaltung/verwaltungsstruktur/dezernat3/strassenverkehrsamt/zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "LEO": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Böblingen",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=BBL"
      }
    ]
  },
  "LER": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leer",
        "url": "https://www.landkreis-leer.de/index.php?object=tx%7c2051.913&ModID=10&FID=13.415.1"
      }
    ]
  },
  "LEV": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Leverkusen",
        "url": "https://www.leverkusen.de/vv/produkte/FB36/Wunschkennzeichen.php"
      }
    ]
  },
  "LF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Altötting",
        "url": "https://www.buergerserviceportal.de/bayern/lkraltoetting/igvwkz"
      },
      {
        "district": "Landkreis Berchtesgadener Land",
        "url": "https://kfz.lra-bgl.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      },
      {
        "district": "Landkreis Traunstein",
        "url": "https://www.buergerserviceportal.de/bayern/lkrtraunstein/igvwkz"
      }
    ]
  },
  "LG": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lüneburg ",
        "url": "http://ekol.lklg.net/"
      }
    ]
  },
  "LH": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Coesfeld",
        "url": "https://www.kreis-coesfeld.de/wkz/?LICENSEIDENTIFIER=coe"
      },
      {
        "district": "Kreis Unna",
        "url": "https://security.kreis-unna.de/wkz/"
      }
    ]
  },
  "LI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lindau (Bodensee)",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=lindau_kreis"
      }
    ]
  },
  "LIB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Elbe-Elster",
        "url": "https://ikfz.brandenburg.de/ikfz/de/kfz-zulassungsbehoerden/ee-elbe-elster/#Wunschkennzeichen%20ONLINE"
      }
    ]
  },
  "LIF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lichtenfels",
        "url": "https://www.buergerserviceportal.de/bayern/lkrlichtenfels/igvwkz"
      }
    ]
  },
  "LIP": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Lippe",
        "url": "https://www.buergerserviceportal.nrw/krz/lkrlippe/igvwkz"
      }
    ]
  },
  "LL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Landsberg am Lech",
        "url": "https://www.buergerserviceportal.de/bayern/lkrlandsberglech/igvwkz"
      }
    ]
  },
  "LM": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Limburg-Weilburg",
        "url": "https://buergerservice.landkreis-limburg-weilburg.de/buergerservice-2/leistungen/HES:entry:48865-VLR/kfz-kennzeichen-wunschkennzeichen/"
      }
    ]
  },
  "LN": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dahme-Spreewald",
        "url": "https://www.dahme-spreewald.info/de/Buergerservice/Wunschkennzeichen/193.html"
      }
    ]
  },
  "LÖ": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lörrach",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=l%C3%B6rrach_kreis&renderer=responsive"
      }
    ]
  },
  "LÖB": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=852609&waid=392"
      }
    ]
  },
  "LOS": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oder-Spree",
        "url": "https://www.landkreis-oder-spree.de/Wirtschaft-Ordnung/Ordnung-Sicherheit/index.php?object=tx%7C2426.2&ModID=10&FID=2426.97.1"
      }
    ]
  },
  "LP": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Soest",
        "url": "https://www.kreis-soest.de/verkehr_wirtschaft/verkehr/zulassung/kennzeichen/wunschkennzeichen.php"
      }
    ]
  },
  "LR": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ortenaukreis",
        "url": "https://kfz2.virtuelles-rathaus.de/igv/servlet/Internetgeschaeftsvorfaelle?MANDANT=08317000&AUFRUF=WKZ"
      }
    ]
  },
  "LRO": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://www.landkreis-rostock.de/de/zustaendigkeit-bau-undverkehrsamt/leistung/313/kfz-wunschkennzeichen_erstmalig_reservieren.html"
      }
    ]
  },
  "LSZ": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Unstrut-Hainich-Kreis",
        "url": "https://ekol.lecos.de/wkz/?LICENSEIDENTIFIER=unstrut-hainich-kreis_kreis"
      }
    ]
  },
  "LU": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Ludwigshafen am Rhein",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "LÜN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Unna",
        "url": "https://security.kreis-unna.de/wkz/"
      }
    ]
  },
  "LUP": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "LWL": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "M": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt München",
        "url": "https://www10.muenchen.de/WuKe/"
      },
      {
        "district": "Landkreis München",
        "url": "https://www.buergerserviceportal.de/bayern/lkrmuenchen/igvwkz"
      }
    ]
  },
  "MA": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Mannheim",
        "url": "https://www.mannheim.de/de/service-bieten/buergerdienste/buergerservice/dienstleistungen/kfz-zulassungen"
      }
    ]
  },
  "MAB": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.kfz-erz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZOKVERKEHR"
      }
    ]
  },
  "MAI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kelheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkelheim/igvwkz"
      },
      {
        "district": "Landkreis Landshut",
        "url": "https://www.landkreis-landshut.de/themen/mobilitaet/kfz-zulassung/?Wunschkennzeichen&view=org&orgid=5e766cff-dcbf-4d80-bda6-b173eb0d7789"
      }
    ]
  },
  "MAK": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wunsiedel im Fichtelgebirge",
        "url": "https://wkz.landkreis-wunsiedel.de/wkz/"
      }
    ]
  },
  "MAL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Landshut ",
        "url": "https://www.landkreis-landshut.de/themen/mobilitaet/kfz-zulassung/?Wunschkennzeichen&view=org&orgid=5e766cff-dcbf-4d80-bda6-b173eb0d7789"
      }
    ]
  },
  "MB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Miesbach",
        "url": "https://www.buergerserviceportal.de/bayern/lkrmiesbach/igvwkz"
      }
    ]
  },
  "MC": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "MD": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Stadt Magdeburg",
        "url": "https://okweb.magdeburg.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "ME": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Mettmann",
        "url": "https://www5.kreis-mettmann.de/wkz/"
      }
    ]
  },
  "MED": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Dithmarschen",
        "url": "https://www.dithmarschen.de/Service-nutzen/Kfz-Zulassung-und-F%C3%BChrerschein/Wunschkennzeichen"
      }
    ]
  },
  "MEG": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Schwalm-Eder-Kreis",
        "url": "https://www.schwalm-eder-kreis.de/Wunschkennzeichen.htm?"
      }
    ]
  },
  "MEI": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Meißen",
        "url": "https://izu.lra-mei.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MEISSEN-WKZ"
      }
    ]
  },
  "MEK": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "MEL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Osnabrück",
        "url": "https://kfzwkz.itebo.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=LKOS"
      }
    ]
  },
  "MER": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Saalekreis",
        "url": "https://stva.saalekreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=SAALEKREIS-WKZ"
      }
    ]
  },
  "MET": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rhön-Grabfeld",
        "url": "https://kfz.rhoen-grabfeld.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "MG": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Mönchengladbach",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=MOENCHENGLADBACH"
      }
    ]
  },
  "MGH": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Main-Tauber-Kreis",
        "url": "https://www.main-tauber-kreis.de/wunschkennzeichen"
      }
    ]
  },
  "MGN": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schmalkalden-Meiningen",
        "url": "http://www.lra-sm.de/?page_id=2708"
      }
    ]
  },
  "MH": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Mülheim an der Ruhr",
        "url": "https://www.muelheim-ruhr.de/wkz/"
      }
    ]
  },
  "MHL": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Unstrut-Hainich-Kreis",
        "url": "https://ekol.lecos.de/wkz/?LICENSEIDENTIFIER=unstrut-hainich-kreis_kreis"
      }
    ]
  },
  "MI": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Minden-Lübbecke",
        "url": "https://www.buergerserviceportal.nrw/krz/mindenluebbecke/igvwkz"
      }
    ]
  },
  "MIL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Miltenberg",
        "url": "https://www.landkreis-miltenberg.de/Wirtschaft,Bauen-Verkehr/Wunschkennzeichen.aspx"
      }
    ]
  },
  "MK": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Märkischer Kreis",
        "url": "https://www.maerkischer-kreis.de/buergerinfo/infoseiten/strassenverkehr/Wunschkennzeichen.php"
      }
    ]
  },
  "MKK": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Main-Kinzig-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.435000"
      }
    ]
  },
  "ML": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mansfeld-Südharz",
        "url": "https://ekol.mansfeldsuedharz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "MM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Memmingen",
        "url": "https://www.memmingen.de/wunschkennzeichen.html"
      }
    ]
  },
  "MN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Unterallgäu",
        "url": "https://www.buergerserviceportal.de/bayern/lkrunterallgaeu/igvwkz"
      }
    ]
  },
  "MO": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Wesel",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=WESEL"
      }
    ]
  },
  "MOD": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostallgäu",
        "url": "https://www.buergerserviceportal.de/bayern/ostallgaeu/igvwkz"
      }
    ]
  },
  "MOL": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Märkisch-Oderland",
        "url": "https://www.landkreismol.de/wkz/"
      }
    ]
  },
  "MON": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Städteregion Aachen",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=aachen_staedteregion_default"
      },
      {
        "district": "Kreis Düren",
        "url": "https://www.kreis-dueren.de/kreishaus/amt/sva/Wunschkennzeichen.php"
      }
    ]
  },
  "MOS": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Neckar-Odenwald-Kreis",
        "url": "https://www.neckar-odenwald-kreis.de/Landratsamt/Verwaltung/Fachbereich+2+_+Umwelt_+Landentwicklung+und+Ordnungswesen/Ordnung+und+Verkehr/KFZ_Zulassung/Wunschkennzeichen.html"
      }
    ]
  },
  "MQ": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Saalekreis",
        "url": "https://stva.saalekreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=SAALEKREIS-WKZ"
      }
    ]
  },
  "MR": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Marburg-Biedenkopf",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.534000"
      }
    ]
  },
  "MS": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Münster",
        "url": "https://www.stadt-muenster.de/wkz/?LICENSEIDENTIFIER=ms"
      }
    ]
  },
  "MSE": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "MSH": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mansfeld-Südharz",
        "url": "https://ekol.mansfeldsuedharz.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "MSP": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Main-Spessart",
        "url": "https://www.buergerserviceportal.de/bayern/lkrmainspessart/igvwkz"
      }
    ]
  },
  "MST": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "MTK": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Main-Taunus-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.436000"
      }
    ]
  },
  "MTL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leipzig",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "MÜ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mühldorf am Inn",
        "url": "https://www.lra-mue.de/buergerservice/themenfelder/kfz-zulassung/wunschkennzeichen.html"
      }
    ]
  },
  "MÜL": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Breisgau-Hochschwarzwald",
        "url": "https://ikfz.komm.one/intelliform/forms/pool/default/Wunschkennzeichen/index?caller=083150"
      }
    ]
  },
  "MÜB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bayreuth ",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      },
      {
        "district": "Landkreis Hof ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhof/igvwkz"
      }
    ]
  },
  "MÜR": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "MW": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV"
      }
    ]
  },
  "MY": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mayen-Koblenz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "MYK": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mayen-Koblenz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "MZ": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Mainz ",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "MZG": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Merzig-Wadern",
        "url": "https://zulassung.merzig-wadern.de/wkz/"
      }
    ]
  },
  "N": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Nürnberg",
        "url": "https://online-service2.nuernberg.de/wkz/"
      },
      {
        "district": "Landkreis Nürnberger Land ",
        "url": "http://wunschkennzeichen.nuernberger-land.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "NAB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Amberg-Sulzbach ",
        "url": "https://www.kreis-as.de/Verwaltung-Politik/Serviceangebot/Online-Anwendungen/Wunschkennzeichen"
      },
      {
        "district": "Landkreis Schwandorf ",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "NAI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hof",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhof/igvwkz"
      }
    ]
  },
  "NAU": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Havelland",
        "url": "https://www.havelland.de/wirtschaft-verkehr/verkehr/kfz-zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "NB": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Neubrandenburg",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=neubrandenburg_stadt"
      }
    ]
  },
  "ND": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neuburg-Schrobenhausen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneuburgschrobenhausen/igvwkz"
      }
    ]
  },
  "NDH": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordhausen",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.062000"
      }
    ]
  },
  "NE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Kreis Neuss",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=NEUSS"
      }
    ]
  },
  "NEU": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Breisgau-Hochschwarzwald",
        "url": "https://ikfz.komm.one/intelliform/forms/pool/default/Wunschkennzeichen/index?caller=083150"
      }
    ]
  },
  "NEA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neustadt an der Aisch-Bad Windsheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneustadtaisch/igvwkz"
      }
    ]
  },
  "NEB": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "NEC": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Coburg / Landkreis Coburg",
        "url": "https://www.zulassungsstelle-coburg.de/portfolio-item/wunschkennzeichen/"
      }
    ]
  },
  "NEN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schwandorf",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "NES": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rhön-Grabfeld",
        "url": "https://kfz.rhoen-grabfeld.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "NEW": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neustadt an der Waldnaab",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneustadtwaldnaab/igvwkz"
      }
    ]
  },
  "NF": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Nordfriesland",
        "url": "https://www.nordfriesland.de/wunschkennzeichen"
      }
    ]
  },
  "NH": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sonneberg",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=sonneberg_kreis"
      }
    ]
  },
  "NI": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nienburg/Weser",
        "url": "https://www.lk-nienburg.de/portal/seiten/informationen-rund-um-das-wunschkennzeichen-272-21500.html?rubrik=5"
      }
    ]
  },
  "NK": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neunkirchen",
        "url": "https://wkz.landkreis-neunkirchen.de:8443/wkz/"
      }
    ]
  },
  "NM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neumarkt in der Oberpfalz",
        "url": "http://kreis-nm.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "NMB": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "NMS": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Stadt Neumünster",
        "url": "https://www.neumuenster.de/buergerservice/dienstleistungen-a-z/leistung/kfz-wunschkennzeichen/"
      }
    ]
  },
  "NÖ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Donau-Ries",
        "url": "https://web3.lra-donau-ries.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "NOH": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Grafschaft Bentheim",
        "url": "https://kfz.grafschaft.de/wkz/"
      }
    ]
  },
  "NOL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=852609&waid=392"
      }
    ]
  },
  "NOM": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Northeim",
        "url": "https://wkz.kdgoe.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=LKNORTHEIM"
      }
    ]
  },
  "NOR": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Aurich",
        "url": "https://www.landkreis-aurich.de/ordnung-veterinaer/ordnungswesen/verkehrswesen/wunschkennzeichen-online-services.html"
      }
    ]
  },
  "NP": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostprignitz-Ruppin",
        "url": "https://www.o-p-r.info/kfzwkz/"
      }
    ]
  },
  "NR": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neuwied",
        "url": "https://kfzonline.ewois.de/"
      },
      {
        "district": "Stadt Neuwied",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "NT": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Esslingen",
        "url": "https://www.landkreis-esslingen.de/start/service/Wunschkennzeichen.html"
      }
    ]
  },
  "NU": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neu-Ulm",
        "url": "https://www.landkreis-nu.de/de/Service-Verwaltung/Unsere-Fachbereiche/Verkehr/Wunschkennzeichen"
      }
    ]
  },
  "NVP": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Rügen",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=vorpommern-ruegen_kreis"
      }
    ]
  },
  "NW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Neustadt an der Weinstraße",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "NWM": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordwestmecklenburg",
        "url": "http://www.nordwestmecklenburg.de/de/kfz-zulassung-detail/leistung/1112/kfz-kennzeichen_reservierung_wunschkennzeichen.html"
      }
    ]
  },
  "NY": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=852609&waid=392"
      }
    ]
  },
  "NZ": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "OA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oberallgäu",
        "url": "https://www.buergerserviceportal.de/bayern/lkroberallgaeu/igvwkz"
      }
    ]
  },
  "OAL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostallgäu",
        "url": "https://www.buergerserviceportal.de/bayern/ostallgaeu/igvwkz"
      }
    ]
  },
  "OB": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Oberhausen",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=OBERHAUSEN"
      }
    ]
  },
  "OBB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Miltenberg",
        "url": "https://public.kitzingen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "OBG": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Stendal",
        "url": "https://kfz.landkreis-stendal.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "OC": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "OCH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Würzburg",
        "url": "https://www.landkreis-wuerzburg.de/Auf_einen_Klick/Wunschkennzeichen/"
      }
    ]
  },
  "OD": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Stormarn",
        "url": "https://igv.osrz-akdb.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=01062_som"
      }
    ]
  },
  "OE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Olpe",
        "url": "https://wunschkennzeichen.kreis-olpe.de/"
      }
    ]
  },
  "OF": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Offenbach am Main",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.413000"
      },
      {
        "district": "Landkreis Offenbach",
        "url": "https://www.kreis-offenbach.de/B%C3%BCrgerservice/Online-Dienste/Wunsch-kennzeichen/"
      }
    ]
  },
  "OG": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ortenaukreis",
        "url": "https://kfz2.virtuelles-rathaus.de/igv/servlet/Internetgeschaeftsvorfaelle?MANDANT=08317000&AUFRUF=WKZ"
      }
    ]
  },
  "OH": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Ostholstein",
        "url": "https://service.kreis-oh.de/wunschkennzeichen/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "OHA": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Göttingen",
        "url": "https://www.landkreisgoettingen.de/themen-leistungen/verkehr-mobilitaet/kraftfahrzeuge/zulassungen-um-abmeldungen"
      }
    ]
  },
  "ÖHR": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Hohenlohekreis",
        "url": "https://www.hohenlohekreis.de/de/buergerservice/bereiche-von-a-z/kfz-zulassung/wunschkennzeichen"
      }
    ]
  },
  "OHV": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oberhavel",
        "url": "https://www.oberhavel.de/wkz/"
      }
    ]
  },
  "OHZ": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Osterholz",
        "url": "https://www.landkreis-osterholz.de/buergerservice/dienstleistungen/kfz-kennzeichen-wunschkennzeichen-900000184-0.html?myMedium=1"
      }
    ]
  },
  "OK": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "OL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Oldenburg / Landkreis Oldenburg",
        "url": "https://wunschkennzeichen.kdo.de/kreisschluessel/03403"
      }
    ]
  },
  "OP": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Leverkusen",
        "url": "https://www.leverkusen.de/vv/produkte/FB36/Wunschkennzeichen.php"
      }
    ]
  },
  "OPR": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostprignitz-Ruppin",
        "url": "https://www.o-p-r.info/kfzwkz/"
      }
    ]
  },
  "OS": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Osnabrück ",
        "url": "https://kfzwkz.itebo.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=STOS"
      },
      {
        "district": "Landkreis Osnabrück ",
        "url": "https://kfzwkz.itebo.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=LKOS"
      }
    ]
  },
  "OSL": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oberspreewald-Lausitz",
        "url": "https://www.osl-online.de/Kfz-Zulassung"
      }
    ]
  },
  "OVI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schwandorf",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "OVL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Vogtlandkreis",
        "url": "https://kfz.vogtlandkreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=VOGTLANDKREISWKZ"
      }
    ]
  },
  "OVP": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostvorpommern",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=vorpommern_greifswald_lk"
      }
    ]
  },
  "OZ": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=nordsachsen_kreis"
      }
    ]
  },
  "P": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Potsdam",
        "url": "https://vv.potsdam.de/vv/produkte/173010100000008537.php"
      }
    ]
  },
  "PA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Passau",
        "url": "https://www.buergerserviceportal.de/bayern/passau/igvwkz"
      },
      {
        "district": "Landkreis Passau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrpassau/igvwkz"
      }
    ]
  },
  "PAF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Pfaffenhofen an der Ilm",
        "url": "https://www.buergerserviceportal.de/bayern/lkrpfaffenhofen/igvwkz"
      }
    ]
  },
  "PAN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rottal-Inn",
        "url": "https://www.buergerserviceportal.de/bayern/lkrrottalinn/igvwkz"
      }
    ]
  },
  "PAR": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kelheim ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkelheim/igvwkz"
      },
      {
        "district": "Landkreis Neumarkt in der Oberpfalz",
        "url": "http://kreis-nm.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "PB": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Paderborn",
        "url": "http://ekol.kreis-paderborn.de/wkz/"
      }
    ]
  },
  "PCH": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "PE": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Peine",
        "url": "https://wkz.landkreis-peine.de/wkz/?renderer=responsive"
      }
    ]
  },
  "PEG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bayreuth ",
        "url": "https://www.buergerserviceportal.de/bayern/lrabayreuth/igvizu"
      },
      {
        "district": "Landkreis Forchheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrforchheim/igvwkz?AUFRUF=WKZ"
      },
      {
        "district": "Landkreis Nürnberger Land",
        "url": "https://wunschkennzeichen.nuernberger-land.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "PF": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Pforzheim",
        "url": "https://www.pforzheim.de/buerger/buergerservice/info/service-bw/leistungen/show/312-wunschkennzeichen-beantragen-oder-reservieren.html"
      },
      {
        "district": "Enzkreis",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-man/servlet/Internetgeschaeftsvorfaelle?MANDANT=08236000&AUFRUF=WKZ"
      }
    ]
  },
  "PI": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Pinneberg",
        "url": "https://www.kreis-pinneberg.de/wunschkennzeichen.html"
      }
    ]
  },
  "PIR": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sächsische Schweiz-Osterzgebirge",
        "url": "https://dienste.landratsamt-pirna.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-PIRNA-WKZ"
      }
    ]
  },
  "PL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Vogtlandkreis",
        "url": "https://kfz.vogtlandkreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=VOGTLANDKREISWKZ"
      }
    ]
  },
  "PLÖ": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Plön",
        "url": "https://www.kreis-ploen.de/B%C3%BCrgerservice/Onlinedienste/Kfz-Wunschkennzeichen"
      }
    ]
  },
  "PM": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Potsdam-Mittelmark",
        "url": "https://www6.potsdam-mittelmark.de/wkz/"
      }
    ]
  },
  "PN": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Orla-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.075000"
      }
    ]
  },
  "PR": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Prignitz",
        "url": "https://kfz.landkreis-prignitz.de/wkz/"
      }
    ]
  },
  "PRÜ": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Eifelkreis Bitburg-Prüm",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "PS": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Pirmasens",
        "url": "https://kfzonline.ewois.de/"
      },
      {
        "district": "Landkreis Südwestpfalz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "PW": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=vorpommern_greifswald_lk"
      }
    ]
  },
  "PZ": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uckermark",
        "url": "https://service.uckermark.de/wkz/"
      }
    ]
  },
  "QFT": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Saalekreis",
        "url": "https://www.saalekreis.de/de/Leistungsausgabe/leistung/90/zustaendigestelle/28/wunschkennzeichen_beantragen.html"
      }
    ]
  },
  "QLB": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Harz",
        "url": "http://www.kreis-hz.de/de/wunschkennzeichen.html"
      }
    ]
  },
  "R": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Regensburg ",
        "url": "https://www.regensburg.de/buergerservice/dienstleistungen/27142/kfz-wunschkennzeichen.html"
      },
      {
        "district": "Landkreis Regensburg ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrregensburg/igvwkz"
      }
    ]
  },
  "RA": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rastatt",
        "url": "https://www.landkreis-rastatt.de/landratsamt/aemteruebersicht/strassenverkehrsamt/auto-fuehrerschein-und-co"
      }
    ]
  },
  "RC": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Vogtlandkreis",
        "url": "https://kfz.vogtlandkreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=VOGTLANDKREISWKZ"
      }
    ]
  },
  "RD": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Rendsburg-Eckernförde",
        "url": "https://www.kreis-rendsburg-eckernfoerde.de/bauen-mobilitaet/verkehr/kfz-zulassungsbehoerde/kennzeichenreservierung"
      }
    ]
  },
  "RDG": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Rügen",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=vorpommern-ruegen_kreis"
      }
    ]
  },
  "RE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Recklinghausen",
        "url": "https://www.kreis-re.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "REG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Regen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrregen/igvwkz"
      }
    ]
  },
  "REH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hof ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhof/igvwkz"
      },
      {
        "district": "Landkreis Wunsiedel im Fichtelgebirge",
        "url": "https://wkz.landkreis-wunsiedel.de/wkz/"
      }
    ]
  },
  "REI": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Berchtesgadener Land",
        "url": "https://kfz.lra-bgl.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "RG": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Meißen",
        "url": "https://izu.lra-mei.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MEISSEN-WKZ"
      }
    ]
  },
  "RH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Roth",
        "url": "https://www.buergerserviceportal.de/bayern/lkrroth/igvwkz"
      }
    ]
  },
  "RI": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schaumburg",
        "url": "http://egov.schaumburg.de/wkz/index.jsp"
      }
    ]
  },
  "RID": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kelheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkelheim/igvwkz"
      }
    ]
  },
  "RIE": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Meißen",
        "url": "https://izu.lra-mei.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MEISSEN-WKZ"
      }
    ]
  },
  "RL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mittelsachsen",
        "url": "https://igv.landkreis-mittelsachsen.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-MITTELSACHSEN-IGV"
      }
    ]
  },
  "RM": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "RN": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Havelland",
        "url": "https://www.havelland.de/wirtschaft-verkehr/verkehr/kfz-zulassungsbehoerde/kennzeichenreservierung/"
      }
    ]
  },
  "RO": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Rosenheim",
        "url": "https://www.rosenheim.de/stadt-buerger/verkehr/kfz-zulassung/wunschkennzeichen.html"
      },
      {
        "district": "Landkreis Rosenheim ",
        "url": "https://www.landkreis-rosenheim.de/e-services/?findTab=wunschkennzeichen"
      }
    ]
  },
  "ROD": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cham",
        "url": "https://wkz.landkreis-cham.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      },
      {
        "district": "Landkreis Schwandorf ",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "ROF": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hersfeld-Rotenburg",
        "url": "https://www.hef-rof.de/landratsamt/kfz-verkehr/kfz-zulassung"
      }
    ]
  },
  "ROK": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Donnersbergkreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "ROL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kelheim ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkelheim/igvwkz"
      },
      {
        "district": "Landkreis Landshut",
        "url": "https://www.landkreis-landshut.de/themen/mobilitaet/kfz-zulassung/?Wunschkennzeichen&view=org&orgid=5e766cff-dcbf-4d80-bda6-b173eb0d7789"
      }
    ]
  },
  "ROS": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://wkz.lkros.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "ROT": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ansbach",
        "url": "https://www.landkreis-ansbach.de/B-rgerservice/Wunschkennzeichen"
      }
    ]
  },
  "ROW": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rotenburg (Wümme)",
        "url": "https://www.lk-row.de/portal/seiten/wunschkennzeichen-1409-23700.html"
      }
    ]
  },
  "RP": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Pfalz-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "RS": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Remscheid",
        "url": "http://wunschkennzeichen.remscheid.de/wkz/"
      }
    ]
  },
  "RSL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Stadt Dessau-Roßlau",
        "url": "http://verwaltung.dessau-rosslau.de/stadt-buerger/ordnung-und-verkehr/wunschkennzeichen.html"
      }
    ]
  },
  "RT": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Reutlingen",
        "url": "https://laikra.komm.one/dvvlaikraIGV21/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ_rtl"
      }
    ]
  },
  "RU": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Saalfeld-Rudolstadt",
        "url": "https://wkz.kreis-slf.de/wkz/"
      }
    ]
  },
  "RÜD": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Rheingau-Taunus-Kreis",
        "url": "http://www.rheingau-taunus.de/zulassungsbehoerde/kfz-online-portal.html"
      }
    ]
  },
  "RÜG": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Rügen",
        "url": "https://www.lk-vr.de/Kreisverwaltung/Onlinedienste/Online-Wunschkennzeichen/"
      }
    ]
  },
  "RV": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ravensburg",
        "url": "https://www.rv.de/ihr+anliegen/fahrzeugzulassung/kennzeichenarten/wunschkennzeichen"
      }
    ]
  },
  "RW": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rottweil",
        "url": "https://www.landkreis-rottweil.de/de/service-verwaltung/online-buergerservice/dienstleistungen-a-z/dienstleistung?view=publish&item=service&id=837"
      }
    ]
  },
  "RZ": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Herzogtum Lauenburg",
        "url": "https://www.kreis-rz.de/Politik-und-Verwaltung/Kreisverwaltung/Kfz-Wunschkennzeichen.php?object=tx,3149.2&ModID=10&FID=327.325.1"
      }
    ]
  },
  "S": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Stuttgart",
        "url": "https://www.stuttgart.de/vv/leistungen/kraftfahrzeugkennzeichen-wunschkennzeichen-reservieren.php"
      }
    ]
  },
  "SAB": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Trier-Saarburg",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "SAD": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schwandorf",
        "url": "https://www.landkreis-schwandorf.de/B%C3%BCrgerservice/Kfz-Zulassung-F%C3%BChrerschein-/"
      }
    ]
  },
  "SAN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Hof ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrhof/igvwkz"
      },
      {
        "district": "Landkreis Kronach ",
        "url": "https://igv.osrz-akdb.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=09476_kro"
      },
      {
        "district": "Landkreis Kulmbach",
        "url": "https://www.buergerserviceportal.de/bayern/lkrkulmbach/igvwkz"
      }
    ]
  },
  "SAW": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Altmarkkreis Salzwedel",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=salzwedel_altmarkkreis&renderer=responsive"
      }
    ]
  },
  "SB": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Regionalverband Saarbrücken",
        "url": "https://sl.buergerserviceportal.de/saarland/saarbruecken/igvwkz"
      }
    ]
  },
  "SBG": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=vorpommern_greifswald_lk"
      }
    ]
  },
  "SBK": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Salzlandkreis",
        "url": "https://kfz.kreis-slk.de/wkz/controller"
      }
    ]
  },
  "SC": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Schwabach",
        "url": "https://service-on.schwabach.de/wkz/"
      }
    ]
  },
  "SCZ": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Orla-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.074000"
      }
    ]
  },
  "SDH": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Kyffhäuserkreis",
        "url": "https://www.kyffhaeuser.de/service-verwaltung/aemter-organigramm/ordnungsverwaltung/fuehrerscheinstelle/"
      }
    ]
  },
  "SDL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Stendal",
        "url": "https://kfz.landkreis-stendal.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=KFZ"
      }
    ]
  },
  "SDT": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uckermark",
        "url": "https://service.uckermark.de/wkz/"
      }
    ]
  },
  "SE": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Segeberg",
        "url": "https://www.segeberg.de/F%C3%BCr-Segeberger/Online-Dienstleistungen/Wunschkennzeichen"
      }
    ]
  },
  "SEB": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sächsische Schweiz-Osterzgebirge",
        "url": "https://dienste.landratsamt-pirna.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LANDKREIS-PIRNA-21"
      }
    ]
  },
  "SEE": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Märkisch-Oderland",
        "url": "https://www.landkreismol.de/wkz/"
      }
    ]
  },
  "SEF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neustadt an der Aisch-Bad Windsheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneustadtaisch/igvwkz"
      }
    ]
  },
  "SEL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wunsiedel im Fichtelgebirge",
        "url": "https://wkz.landkreis-wunsiedel.de/wkz/"
      }
    ]
  },
  "SFB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Oberspreewald-Lausitz",
        "url": "https://wkz.kreis-osl.de:4443/wkz/"
      }
    ]
  },
  "SFT": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Salzlandkreis",
        "url": "https://kfz.kreis-slk.de/wkz/controller"
      }
    ]
  },
  "SG": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Solingen",
        "url": "https://www.solingen.de/de/dienstleistungen/33-16-wunschkennzeichen/"
      }
    ]
  },
  "SGH": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mansfeld-Südharz",
        "url": "http://www.mansfeldsuedharz.de/de/322,1154.html?accessibility%5Bfontsize%5D=-2"
      }
    ]
  },
  "SHA": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schwäbisch Hall",
        "url": "https://kfz.virtuelles-rathaus.de/igv2-sha/servlet/Internetgeschaeftsvorfaelle?DIALOG=WKZ"
      }
    ]
  },
  "SHG": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schaumburg",
        "url": "http://egov.schaumburg.de/wkz/index.jsp"
      }
    ]
  },
  "SHK": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Holzland-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.074000"
      }
    ]
  },
  "SHL": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Suhl",
        "url": "http://suhltrifft.de/content/view/289/1186/"
      }
    ]
  },
  "SI": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Siegen-Wittgenstein",
        "url": "https://wunschkennzeichen.siegen-wittgenstein.de/"
      }
    ]
  },
  "SIG": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sigmaringen",
        "url": "https://www.landkreis-sigmaringen.de/de/Landratsamt/Dienstleistungen/A-Z?view=publish&item=service&id=2122"
      }
    ]
  },
  "SIM": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Hunsrück-Kreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "SK": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Saalekreis",
        "url": "https://stva.saalekreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=SAALEKREIS-WKZ"
      }
    ]
  },
  "SL": {
    "state": "Schleswig-Holstein",
    "hint": "",
    "links": [
      {
        "district": "Kreis Schleswig-Flensburg",
        "url": "https://www.schleswig-flensburg.de/Aktuelles-Service/Onlinedienste/Wunschkennzeichen/Wunschkennzeichen-Online"
      }
    ]
  },
  "SLE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Düren",
        "url": "https://kfz-egov.regioit.de/wkz/?LICENSEIDENTIFIER=dueren_kreis"
      },
      {
        "district": "Kreis Euskirchen",
        "url": "https://www.kreis-euskirchen.de/service/strassenverkehr/wunschkennzeichen.php"
      }
    ]
  },
  "SLF": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Saalfeld-Rudolstadt",
        "url": "https://wkz.kreis-slf.de/wkz/"
      }
    ]
  },
  "SLK": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Salzlandkreis",
        "url": "https://kfz.kreis-slk.de/wkz/controller"
      }
    ]
  },
  "SLN": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Altenburger Land",
        "url": "https://igv.osrz-akdb.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=16077_atn"
      }
    ]
  },
  "SLS": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Saarlouis",
        "url": "https://www.kreis-saarlouis.de/Aktuelles/Wunschkennzeichen-Service-wird-derzeit-ueberarbeitet.html?"
      }
    ]
  },
  "SLÜ": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Main-Kinzig-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.435000"
      }
    ]
  },
  "SLZ": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Wartburgkreis",
        "url": "https://www.wartburgkreis.de/leben-im-wartburgkreis/news-detailseite/wunschkennzeichen-online-reservieren"
      }
    ]
  },
  "SM": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Schmalkalden-Meiningen",
        "url": "http://www.lra-sm.de/?page_id=2708"
      }
    ]
  },
  "SN": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Schwerin",
        "url": "https://www.schwerin.de/politik-verwaltung/dienstleistungen/verwaltungsleistungen/Kraftfahrzeugkennzeichen-Reservierung-erstmalig/"
      }
    ]
  },
  "SO": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Soest",
        "url": "https://wunschkennzeichen.kreis-soest.de/"
      }
    ]
  },
  "SOB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neuburg-Schrobenhausen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneuburgschrobenhausen/igvwkz"
      }
    ]
  },
  "SOG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weilheim-Schongau",
        "url": "http://ikolkom-wm.bayern.de/ekol-kfz/wkz/index.jsp"
      }
    ]
  },
  "SOK": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Orla-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.075000"
      }
    ]
  },
  "SÖM": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sömmerda",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "SON": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Sonneberg",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=sonneberg_kreis"
      }
    ]
  },
  "SP": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Speyer",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "SPB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Spree-Neiße",
        "url": "https://wunschkennzeichen.lkspn.de/wkz/"
      }
    ]
  },
  "SPN": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Spree-Neiße",
        "url": "https://wunschkennzeichen.lkspn.de/wkz/"
      }
    ]
  },
  "SR": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Straubing-Bogen",
        "url": "https://www.landkreis-straubing-bogen.de/zulassung/index.html"
      },
      {
        "district": "Stadt Straubing",
        "url": "https://www.buergerserviceportal.de/bayern/straubing/igvwkz"
      }
    ]
  },
  "SRB": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Märkisch-Oderland",
        "url": "https://www.landkreismol.de/wkz/"
      }
    ]
  },
  "SRO": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Saale-Holzland-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.16.074000"
      }
    ]
  },
  "ST": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Steinfurt",
        "url": "https://www.kreis-steinfurt.de/kv_steinfurt/Kreisverwaltung/%C3%84mter/Stra%C3%9Fenverkehrsamt/Zulassungsstelle/Aufgaben%20&%20Dienstleistungen/Wunschkennzeichen/"
      }
    ]
  },
  "STA": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Starnberg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrstarnberg/igvwkz"
      }
    ]
  },
  "STB": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigslust-Parchim",
        "url": "http://www.kreis-lup.de/leben-im-landkreis/verkehr-ordnung-sicherheit/kfz-zulassung/"
      }
    ]
  },
  "STD": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Stade",
        "url": "https://www.landkreis-stade.de/portal/seiten/wunschkennzeichen-901000002-20350.html"
      }
    ]
  },
  "STE": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Lichtenfels",
        "url": "https://www.buergerserviceportal.de/bayern/lkrlichtenfels/igvwkz"
      }
    ]
  },
  "STL": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "SU": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Rhein-Sieg-Kreis",
        "url": "https://www.rhein-sieg-kreis.de/vv/produkte/Amt_36/Wunschkennzeichen.php"
      }
    ]
  },
  "SUL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Amberg-Sulzbach",
        "url": "https://www.buergerserviceportal.de/bayern/lkrambergsulzbach/igvwkz"
      }
    ]
  },
  "SÜW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Südliche Weinstraße",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "SW": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Schweinfurt ",
        "url": "https://schweinfurtonline2.bayern.de/eKOL-WKZ/"
      },
      {
        "district": "Landkreis Schweinfurt",
        "url": "https://www.landkreis-schweinfurt.de/service-infos/serviceleistungen-informationen/serviceinfos/detail/wunschkennzeichen-1385"
      }
    ]
  },
  "SWA": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Rheingau-Taunus-Kreis",
        "url": "http://www.rheingau-taunus.de/zulassungsbehoerde/kfz-online-portal.html"
      }
    ]
  },
  "SZ": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Salzgitter",
        "url": "https://app-16.salzgitter.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "SZB": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "TBB": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Main-Tauber-Kreis",
        "url": "https://www.main-tauber-kreis.de/wunschkennzeichen"
      }
    ]
  },
  "TDO": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://www.landkreis-nordsachsen.de/behoerdenwegweiser.html?m=tasks-detail&id=2626"
      }
    ]
  },
  "TE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Steinfurt",
        "url": "https://www.kreis-steinfurt.de/kv_steinfurt/Kreisverwaltung/%C3%84mter/Stra%C3%9Fenverkehrsamt/Zulassungsstelle/Aufgaben%20&%20Dienstleistungen/Wunschkennzeichen/"
      }
    ]
  },
  "TET": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rostock",
        "url": "https://wkz.lkros.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "TF": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Teltow-Fläming",
        "url": "http://www.teltow-flaeming.de/de/was-erledige-ich-wo/online-services/wunschkennzeichen.php"
      }
    ]
  },
  "TG": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://www.landkreis-nordsachsen.de/behoerdenwegweiser.html?m=tasks-detail&id=2626"
      }
    ]
  },
  "TIR": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Tirschenreuth",
        "url": "https://www.kreis-tir.de/fachbereiche/strassen-verkehr-oepnv/auto-und-strassenverkehr/kfz-zulassung/wunschkennzeichen-online/"
      }
    ]
  },
  "TO": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordsachsen",
        "url": "https://www.landkreis-nordsachsen.de/behoerdenwegweiser.html?m=tasks-detail&id=2626"
      }
    ]
  },
  "TÖL": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Tölz-Wolfratshausen",
        "url": "https://www.lra-toelz.de/kfz-zulassungsbehoerde-bad-toelz"
      }
    ]
  },
  "TP": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uckermark",
        "url": "https://service.uckermark.de/wkz/"
      }
    ]
  },
  "TR": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Trier-Saarburg / Stadt Trier",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "TS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Traunstein",
        "url": "https://www.buergerserviceportal.de/bayern/lkrtraunstein/igvwkz"
      }
    ]
  },
  "TÜ": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Tübingen",
        "url": "https://www.kreis-tuebingen.de/13878555.html"
      }
    ]
  },
  "TUT": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Tuttlingen",
        "url": "https://www.landkreis-tuttlingen.de/Kreisverwaltung/%C3%84mter-Aufgaben/Stra%C3%9Fenverkehrsamt/Wunschkennzeichen-beantragen-oder-reservieren.php?object=tx,2527.2&ModID=10&FID=2527.773.1&NavID=2328.115&La=1&ort="
      }
    ]
  },
  "UE": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uelzen",
        "url": "https://www.landkreis-uelzen.de/home/landkreis-uelzen-politik-verwaltung-wirtschaft/verwaltung/online-buergerservice/Wunschkennzeichen-0.aspx"
      }
    ]
  },
  "UEM": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://www.kreis-vg.de/Landkreis/Wunschkennzeichen"
      }
    ]
  },
  "UFF": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neustadt an der Aisch-Bad Windsheim",
        "url": "https://www.buergerserviceportal.de/bayern/lkrneustadtaisch/igvwkz"
      }
    ]
  },
  "UH": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Unstrut-Hainich-Kreis",
        "url": "https://www.unstrut-hainich-kreis.de/index.php/strassenverkehr/9-website/253-kfz-neuzulassung"
      }
    ]
  },
  "UL": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Stadt Ulm",
        "url": "https://www.zulassung-ulm.de/Startseite/wunschkennzeichen.html"
      },
      {
        "district": "Alb-Donau-Kreis",
        "url": "https://www.zulassung-ulm.de/Startseite/wunschkennzeichen.html"
      }
    ]
  },
  "UM": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Uckermark",
        "url": "https://service.uckermark.de/wkz/"
      }
    ]
  },
  "UN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Unna",
        "url": "https://security.kreis-unna.de/wkz/"
      }
    ]
  },
  "USI": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Hochtaunuskreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.434000"
      }
    ]
  },
  "V": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Vogtlandkreis",
        "url": "https://kfz.vogtlandkreis.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=VOGTLANDKREISWKZ"
      }
    ]
  },
  "VAI": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ludwigsburg",
        "url": "https://www.landkreis-ludwigsburg.de/de/verkehr-sicherheit-ordnung/auto-kfz/kfz-zulassungsbehoerde/"
      }
    ]
  },
  "VB": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Vogelsbergkreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.535000"
      }
    ]
  },
  "VEC": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vechta",
        "url": "https://www.landkreis-vechta.de/ordnung-und-verkehr/wunschkennzeichen.html"
      }
    ]
  },
  "VER": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Verden",
        "url": "https://www.landkreis-verden.de/portal/seiten/wunschkennzeichen-901001521-20600.html"
      }
    ]
  },
  "VG": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://www.kreis-vg.de/Landkreis/Wunschkennzeichen"
      }
    ]
  },
  "VIB": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Landshut ",
        "url": "https://www.landkreis-landshut.de/themen/mobilitaet/kfz-zulassung/?Wunschkennzeichen&view=org&orgid=5e766cff-dcbf-4d80-bda6-b173eb0d7789"
      },
      {
        "district": "Landkreis Rottal-Inn ",
        "url": "https://www.buergerserviceportal.de/bayern/lkrrottalinn/igvwkz"
      }
    ]
  },
  "VIE": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Viersen",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=VIERSEN"
      }
    ]
  },
  "VK": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Stadt Völklingen",
        "url": "http://212.88.154.153:8080/vorfahrt-v3p7-wkz/servlet/Internetzulassungen?btn_wkz=start"
      }
    ]
  },
  "VOH": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Neustadt an der Waldnaab",
        "url": "https://www.neustadt.de/beratung-service/verkehrswesen-und-mobilitaet/zulassung/wunschkennzeichen/"
      }
    ]
  },
  "VR": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Rügen",
        "url": "https://www.lk-vr.de/Kreisverwaltung/B%C3%BCrgerservice/Zulassungsbeh%C3%B6rde/"
      }
    ]
  },
  "VS": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Schwarzwald-Baar-Kreis",
        "url": "https://www.lrasbk.de/Direkt-zu/Wunschkennzeichen/Wunschkennzeichen-beantragen-oder-reservieren.php?object=tx,2961.2&ModID=10&FID=2961.715.1&NavID=2961.1535&La=1&call=1"
      }
    ]
  },
  "W": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Wuppertal",
        "url": "https://www.wuppertal.de/wkz/"
      }
    ]
  },
  "WA": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Waldeck-Frankenberg",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.635000"
      }
    ]
  },
  "WAF": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Warendorf",
        "url": "https://www.kreis-warendorf.de/kfz/wkz/"
      }
    ]
  },
  "WAK": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Wartburgkreis",
        "url": "https://www.wartburgkreis.de/leben-im-wartburgkreis/ordnung-sicherheit/kfz-zulassung"
      }
    ]
  },
  "WAN": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Herne",
        "url": "https://www.herne.de/Leichte-Sprache/Dienstleistungen/Wunsch%C2%B7kennzeichen/"
      }
    ]
  },
  "WAT": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Bochum",
        "url": "https://www.bochum.de/Buero-fuer-Kfz-Angelegenheiten/Dienstleistungen-und-Infos/Wunschkennzeichen"
      }
    ]
  },
  "WB": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wittenberg",
        "url": "https://www.landkreis-wittenberg.de/de/wunschkennzeichen/kfz-online-20000419.html"
      }
    ]
  },
  "WBS": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Eichsfeld",
        "url": "https://www.kreis-eic.de/zulassung.html"
      }
    ]
  },
  "WDA": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Zwickau",
        "url": "https://wunschkennzeichen.landkreis-zwickau.de/ekol-wkz-zl/"
      }
    ]
  },
  "WE": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Weimar",
        "url": "https://stadt.weimar.de/buergerservice/dienstleistung/wunschkennzeichen-330/"
      }
    ]
  },
  "WEL": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Limburg-Weilburg",
        "url": "https://buergerservice.landkreis-limburg-weilburg.de/buergerservice-2/leistungen/HES:entry:48865-VLR/kfz-kennzeichen-wunschkennzeichen/"
      }
    ]
  },
  "WEN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Weiden in der Oberpfalz",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=weiden_idopf_stadt&renderer=responsive"
      }
    ]
  },
  "WER": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Dillingen an der Donau",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=dillingen_kreis"
      }
    ]
  },
  "WES": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Kreis Wesel",
        "url": "https://verkehr-igv.krzn.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=IZU&MANDANT=WESEL"
      }
    ]
  },
  "WF": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wolfenbüttel",
        "url": "http://wkz.lkwf.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "WHV": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Wilhelmshaven",
        "url": "https://www.wilhelmshaven.de/Stadtverwaltung/Dienststellen/32_Oeffentliche_Sicherheit_und_Ordnung/32-00_KFZ-Zulassung/Kfz-Wunschkennzeichen.php"
      }
    ]
  },
  "WI": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Wiesbaden ",
        "url": "https://ekol-web.wiesbaden.de/wkz/"
      }
    ]
  },
  "WIL": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bernkastel-Wittlich",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "WIS": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Nordwestmecklenburg",
        "url": "https://www.nordwestmecklenburg.de/de/artikel/wunschkennzeichen.html"
      }
    ]
  },
  "WIT": {
    "state": "Nordrhein-Westfalen",
    "hint": "",
    "links": [
      {
        "district": "Ennepe-Ruhr-Kreis",
        "url": "https://kfzwk.en-kreis.de/wkz/"
      }
    ]
  },
  "WIZ": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Werra-Meißner-Kreis",
        "url": "https://www.werra-meissner-kreis.de/fachbereiche-einrichtungen/fb-3-aufsicht-ordnung-und-verkehr/35-strassenverkehrsbehoerde/kfz-zulassung"
      }
    ]
  },
  "WK": {
    "state": "Brandenburg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ostprignitz-Ruppin",
        "url": "https://www.o-p-r.info/kfzwkz/"
      }
    ]
  },
  "WL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Harburg",
        "url": "https://www.landkreis-harburg.de/buergerservice/dienstleistungen/kfz-zulassung-wunschkennzeichen-1185-0.html?myMedium=1"
      }
    ]
  },
  "WLG": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Vorpommern-Greifswald",
        "url": "https://www.kreis-vg.de/Landkreis/Wunschkennzeichen"
      }
    ]
  },
  "WM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weilheim-Schongau",
        "url": "http://ikolkom-wm.bayern.de/ekol-kfz/wkz/index.jsp"
      }
    ]
  },
  "WMS": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "WN": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Rems-Murr-Kreis",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WNL"
      }
    ]
  },
  "WND": {
    "state": "Saarland",
    "hint": "",
    "links": [
      {
        "district": "Landkreis St. Wendel",
        "url": "https://egov.lkwnd.de/wkz/"
      }
    ]
  },
  "WO": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Worms",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "WOB": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Stadt Wolfsburg",
        "url": "https://www.wolfsburg.de/dienstleistungsbeschreibungen/wunschkennzeichen"
      }
    ]
  },
  "WOH": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Kassel",
        "url": "http://www.serviceportal-kassel.de/cms05/dienstleistungen/029911/index.html"
      }
    ]
  },
  "WOL": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Ortenaukreis",
        "url": "https://kfz2.virtuelles-rathaus.de/igv/servlet/Internetgeschaeftsvorfaelle?MANDANT=08317000&AUFRUF=WKZ"
      }
    ]
  },
  "WOR": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Bad Tölz-Wolfratshausen",
        "url": "https://www.lra-toelz.de/kfz-zulassungsbehoerde-bad-toelz"
      },
      {
        "district": "Landkreis München",
        "url": "https://www.buergerserviceportal.de/bayern/lkrmuenchen/igvwkz"
      },
      {
        "district": "Landkreis Starnberg",
        "url": "https://www.buergerserviceportal.de/bayern/lkrstarnberg/igvwkz"
      }
    ]
  },
  "WOS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Freyung-Grafenau",
        "url": "https://www.buergerserviceportal.de/bayern/lkrfreyunggrafenau/igvwkz"
      }
    ]
  },
  "WR": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Harz",
        "url": "http://www.kreis-hz.de/de/wunschkennzeichen.html"
      }
    ]
  },
  "WRN": {
    "state": "Mecklenburg-Vorpommern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Mecklenburgische Seenplatte",
        "url": "https://ikol.ikt-ost.de/wkz/?LICENSEIDENTIFIER=mecklenburgische_seenplatte_lk"
      }
    ]
  },
  "WS": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Rosenheim",
        "url": "https://www.landkreis-rosenheim.de/e-services/?findTab=wunschkennzeichen"
      }
    ]
  },
  "WSF": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "WST": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ammerland",
        "url": "https://www.ammerland.de/Service/Online-Dienste/Wunschkennzeichen/"
      }
    ]
  },
  "WSW": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=853046&waid=394"
      }
    ]
  },
  "WT": {
    "state": "Baden-Wuerttemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Waldshut",
        "url": "https://www.landkreis-waldshut.de/organisation/aemtereigenbetriebe-von-a-z/strassenverkehrsamt/zulassungsbehoerde/wunschkennzeichen"
      }
    ]
  },
  "WTM": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wittmund",
        "url": "https://www.landkreis-wittmund.de/LebenArbeiten/Verkehr/KFZZulassung/Wunschkennzeichen/Wunschkennzeichenreservierung.aspx"
      }
    ]
  },
  "WÜ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Stadt Würzburg",
        "url": "https://www.buergerserviceportal.de/bayern/wuerzburg/igvwkz"
      },
      {
        "district": "Landkreis Würzburg",
        "url": "https://www.landkreis-wuerzburg.de/Auf_einen_Klick/Wunschkennzeichen/"
      }
    ]
  },
  "WUG": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Weißenburg-Gunzenhausen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrweissenburggunzenhausen/igvwkz"
      }
    ]
  },
  "WÜM": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cham",
        "url": "https://wkz.landkreis-cham.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ"
      }
    ]
  },
  "WUN": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Wunsiedel im Fichtelgebirge",
        "url": "https://www.landkreis-wunsiedel.de/zulassungstelle/wunschkennzeichen"
      }
    ]
  },
  "WUR": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Leipzig",
        "url": "https://www.lk-l.net/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=LK-LEIPZIGIZU"
      }
    ]
  },
  "WW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Westerwaldkreis",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "WZ": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Lahn-Dill-Kreis",
        "url": "https://kfzonline.ekom21.de/kfzonline.public/start.html?oe=00.00.06.532000"
      }
    ]
  },
  "WZL": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Börde",
        "url": "https://www.landkreis-boerde.de/wkz/index.jsp?s=5ba8eb9c1156d2b1a55ebb21b29c568585c369db"
      }
    ]
  },
  "Z": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Zwickau",
        "url": "https://wunschkennzeichen.landkreis-zwickau.de/ekol-wkz-zl/"
      }
    ]
  },
  "ZE": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Anhalt-Bitterfeld",
        "url": "https://ekol-asp.lecos.de/ekol/wkz/?LICENSEIDENTIFIER=anhalt-bitterfeld_kreis"
      }
    ]
  },
  "ZEL": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Cochem-Zell",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "ZI": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Görlitz",
        "url": "https://www.kreis-goerlitz.de/city_info/webaccessibility/index.cfm?item_id=853046&waid=394"
      }
    ]
  },
  "ZIG": {
    "state": "Hessen",
    "hint": "",
    "links": [
      {
        "district": "Schwalm-Eder-Kreis",
        "url": "https://www.schwalm-eder-kreis.de/Wunschkennzeichen.htm?"
      }
    ]
  },
  "ZP": {
    "state": "Sachsen",
    "hint": "",
    "links": [
      {
        "district": "Erzgebirgskreis",
        "url": "https://www.erzgebirgskreis.de/landratsamt-service/struktur-aufgaben/anliegen-von-a-bis-z/wunschkennzeichen-beantragen"
      }
    ]
  },
  "ZR": {
    "state": "Thueringen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Greiz",
        "url": "https://www.landkreis-greiz.de/landkreis-greiz/organisatorisch/kreisverwaltung/redakteursebene-aemter/ordnungsamt/strassenverkehrsbehoerde/zulassung"
      }
    ]
  },
  "ZW": {
    "state": "Rheinland-Pfalz",
    "hint": "",
    "links": [
      {
        "district": "Stadt Zweibrücken",
        "url": "https://kfzonline.ewois.de/"
      },
      {
        "district": "Landkreis Südwestpfalz",
        "url": "https://kfzonline.ewois.de/"
      }
    ]
  },
  "ZZ": {
    "state": "Sachsen-Anhalt",
    "hint": "",
    "links": [
      {
        "district": "Burgenlandkreis",
        "url": "https://ekol.blk.de/wkz/"
      }
    ]
  },
  "SLG": {
    "state": "Baden-Württemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ravensburg",
        "url": "https://www.rv.de/18495374"
      }
    ]
  },
  "SMÜ": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Augsburg",
        "url": "https://www.buergerserviceportal.de/bayern/lkraugsburg/igvwkz"
      }
    ]
  },
  "SY": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Diepholz",
        "url": "https://wunschkennzeichen.kdo.de/kreisschluessel/03251"
      }
    ]
  },
  "TT": {
    "state": "Baden-Württemberg",
    "hint": "",
    "links": [
      {
        "district": "Bodenseekreis",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=FNL"
      }
    ]
  },
  "ÜB": {
    "state": "Baden-Württemberg",
    "hint": "",
    "links": [
      {
        "district": "Bodenseekreis, Landkreis Ravensburg",
        "url": "https://laikra-igv.komm.one/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=FNL"
      },
      {
        "district": "Landkreis Ravensburg",
        "url": "https://onlinedienste.rv.de/detail/-/vr-bis-detail/dienstleistung/32680/show"
      }
    ]
  },
  "VIT": {
    "state": "Bayern",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Regen",
        "url": "https://www.buergerserviceportal.de/bayern/lkrregen/igvwkz"
      }
    ]
  },
  "WG": {
    "state": "Baden-Württemberg",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Ravensburg",
        "url": "https://www.rv.de/18495374"
      }
    ]
  },
  "WTL": {
    "state": "Niedersachsen",
    "hint": "",
    "links": [
      {
        "district": "Landkreis Osnabrück",
        "url": "https://kfzwkz.itebo.de/verkehr-igv/servlet/Internetgeschaeftsvorfaelle?AUFRUF=WKZ&MANDANT=LKOS"
      }
    ]
  }
};

  /**
   * Kleine Logging-Hilfe. Standardmäßig aus, damit die Konsole sauber bleibt.
   */
  function log() {
    if (state.debug && window.console && window.console.log) {
      window.console.log.apply(window.console, arguments);
    }
  }

  /**
   * Sicherer String-Konverter.
   */
  function asString(value) {
    return value == null ? "" : String(value);
  }

  /**
   * Prüft Teilstrings ohne String.prototype.includes, damit auch ältere Browser
   * nicht unnötig Probleme machen.
   */
  function contains(value, needle) {
    return asString(value).indexOf(needle) !== -1;
  }

  /**
   * Ermittelt den Wert des ersten passenden Elements.
   */
  function getValue(selector) {
    var $element = $(selector).first();
    return $element.length ? asString($element.val()) : "";
  }

  /**
   * Setzt einen Wert nur dann, wenn das Element existiert.
   */
  function setValue(selector, value) {
    var $element = $(selector);
    if ($element.length) {
      $element.val(value);
    }
  }

  /**
   * Sichtbarkeit per display steuern.
   */
  function setVisible(selector, visible, displayValue) {
    var $element = $(selector);
    if ($element.length) {
      $element.css("display", visible ? (displayValue || "block") : "none");
    }
  }

  /**
   * Buttons/Elemente über visibility steuern, ohne Layoutbreite zu verlieren.
   */
  function setVisibility(selector, visible) {
    var $element = $(selector);
    if ($element.length) {
      $element.css("visibility", visible ? "visible" : "hidden");
    }
  }

  /**
   * Zustand in alte globale Variablen spiegeln.
   */
  function syncLegacyGlobals() {
    window.kzLength = state.kzLength;
    window.maxLength = state.maxLength;
    window.zeilezweiLength = state.zeilezweiLength;
    window.maxLengthZeileZwei = state.maxLengthZeileZwei;
    window.zeileeinsLength = state.zeileeinsLength;
    window.maxLengthZeileEins = state.maxLengthZeileEins;
    window.zusatzzeichen = state.zusatzzeichen;
  }

  /**
   * Entfernt verbotene Zeichenkombinationen.
   */
  function removeForbiddenCombinations(value, combinations) {
    var cleanValue = asString(value);

    $.each(combinations, function (_index, combination) {
      cleanValue = cleanValue.replace(new RegExp(combination, "gi"), "");
    });

    return cleanValue;
  }

  /**
   * Kürzt Eingaben auf eine maximale Länge.
   */
  function limitLength(value, maxLength) {
    value = asString(value);
    return value.length > maxLength ? value.substr(0, maxLength) : value;
  }

  /**
   * Sanitizer für Zulassungsbezirk, z. B. "B", "M", "AÖ".
   */
  function sanitizeDistrict(value) {
    value = asString(value).replace(/[^a-zA-ZÜÄÖüäö]/g, "");
    value = removeForbiddenCombinations(value, ["SS", "NS", "HJ", "KZ"]);
    return limitLength(value.toUpperCase(), 3);
  }

  /**
   * Sanitizer für Buchstaben nach dem Zulassungsbezirk.
   */
  function sanitizePlateLetters(value) {
    value = asString(value).replace(/[^a-zA-Z]/g, "");
    value = removeForbiddenCombinations(value, ["SS", "SA", "NS", "HJ", "KZ"]);
    return limitLength(value.toUpperCase(), 2);
  }

  /**
   * Sanitizer für Ziffernfeld.
   */
  function sanitizePlateNumbers(value) {
    value = asString(value).replace(/[^0-9]/g, "");
    return limitLength(value, 6);
  }

  /**
   * Sanitizer für Parkplatzkennzeichen.
   */
  function sanitizeParkingPlate(value) {
    value = asString(value).replace(/[^a-zA-ZÜÄÖüäö0-9 .&-]/g, "");
    value = removeForbiddenCombinations(value, ["HJ", "KZ"]);
    return limitLength(value.toUpperCase(), 9);
  }

  /**
   * Führt einen kurzen Layout-Refresh in der Vorschau aus.
   * Das ersetzt die mehrfach wiederholten min-width-Time-outs aus dem alten Code.
   */
  function pulsePreview(selector) {
    var $element = $(selector);
    if (!$element.length) {
      return;
    }

    window.setTimeout(function () {
      $element.css("min-width", "10px");
    }, 10);

    window.setTimeout(function () {
      $element.css("min-width", "0px");
    }, 20);
  }

  /**
   * Erzeugt ein echtes DOM-Event mit Bubble-Verhalten.
   * Der Fallback hält ältere Browser kompatibel, die den Event-Konstruktor
   * noch nicht zuverlässig unterstützen.
   */
  function createBubblingEvent(eventName) {
    var event;

    if (typeof window.Event === "function") {
      return new window.Event(eventName, { bubbles: true });
    }

    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    return event;
  }

  /**
   * YMQ reagiert teilweise nur auf echte input/change Events.
   * Deshalb wird der Wert kurz minimal verändert und direkt wiederhergestellt.
   */
  function triggerInputChange(selector) {
    var inputField = document.querySelector(selector);
    var originalValue;

    if (!inputField) {
      return;
    }

    originalValue = inputField.value;

    inputField.value = originalValue + " ";
    inputField.dispatchEvent(createBubblingEvent("input"));
    inputField.dispatchEvent(createBubblingEvent("change"));

    window.setTimeout(function () {
      inputField.value = originalValue;
      inputField.dispatchEvent(createBubblingEvent("input"));
      inputField.dispatchEvent(createBubblingEvent("change"));
    }, 0);
  }

  /**
   * Aktueller Wert der YMQ-Kennzeichenart.
   */
  function getPlateTypeValue() {
    return getValue(SELECTORS.ymqPlateTypeSelect);
  }

  /**
   * Ist das aktuelle Produkt/Variant ein Saisonkennzeichen?
   */
  function isSeasonPlate() {
    return contains(getPlateTypeValue(), "Saisonkennzeichen");
  }

  /**
   * Prüft Steuerbefreit/Grün und setzt Vorschau-Farbe.
   */
  function updateGreenPlateStyle() {
    var isGreenPlate = contains(getPlateTypeValue(), "Steuerbefreit (Grün)");
    var isTractorPage =
      contains(window.location.href, "traktor") ||
      $(".product-traktor-kennzeichen").length > 0;

    // Traktor-Seiten sind im alten Code grundsätzlich grün.
    // Deshalb dort nicht durch einen leeren/anderen YMQ-Wert auf schwarz zurücksetzen.
    if (isTractorPage && !isGreenPlate) {
      return;
    }

    $(SELECTORS.platePreview).css({
      color: isGreenPlate ? "#008a00" : "#000",
      "border-color": isGreenPlate ? "#008a00" : "#000"
    });
  }

  /**
   * Blendet Saison-Monatsfelder und Saison-Vorschau passend zur Variante ein.
   */
  function updateSeasonVisibility() {
    var showSeason = isSeasonPlate();

    setVisible(SELECTORS.seasonStartOption, showSeason);
    setVisible(SELECTORS.seasonEndOption, showSeason);
    setVisible(SELECTORS.seasonWrapper, showSeason);

    $(SELECTORS.seasonStartPreview).text(getValue(SELECTORS.ymqStartMonthSelect));
    $(SELECTORS.seasonEndPreview).text(getValue(SELECTORS.ymqEndMonthSelect));
  }

  /**
   * Synchronisiert die sichtbare Kennzeichen-Vorschau in das versteckte YMQ-Feld.
   */
  function updateYmqPlateValue() {
    var district = getValue(SELECTORS.plateDistrictInput).toUpperCase();
    var letters = getValue(SELECTORS.plateLettersInput).toUpperCase();
    var numbers = getValue(SELECTORS.plateNumbersInput).toUpperCase();
    var legend = district + " " + letters + " " + numbers + state.zusatzzeichen;

    if (isSeasonPlate()) {
      legend += " " + getValue(SELECTORS.ymqStartMonthSelect) + " " + getValue(SELECTORS.ymqEndMonthSelect);
    }

    setValue(SELECTORS.ymqPlateInput, legend);
    triggerInputChange(SELECTORS.ymqPlateInput);
  }

  /**
   * Setzt die Schriftweite für normal breite Kennzeichen.
   */
  function kzMittelschrift() {
    $(SELECTORS.platePreview).css("letter-spacing", "-1px");
  }

  /**
   * Setzt die Schriftweite für volle Kennzeichen.
   */
  function kzEngschrift() {
    $(SELECTORS.platePreview).css("letter-spacing", "-2.5px");
  }

  /**
   * Spezielle 255/240-Logik für Traktor und Leichtkraftrad.
   * Diese Logik bleibt erhalten, ist aber defensiver geschrieben.
   */
  function applyLegacyCompactPlateLimits() {
    var isSeasonRadioChecked = $(
      ".product-traktor-kennzeichen .kennzeichenart input:radio, " +
        ".product-leichtkraftrad-kennzeichen .kennzeichenart input:radio"
    )
      .eq(1)
      .is(":checked");

    var is255Selected = $(
      ".product-traktor-kennzeichen .kz-length select option, " +
        ".product-leichtkraftrad-kennzeichen .kz-length select option"
    )
      .eq(1)
      .is(":checked");

    var is240Selected = $(
      ".product-traktor-kennzeichen .kz-length select option, " +
        ".product-leichtkraftrad-kennzeichen .kz-length select option"
    )
      .eq(2)
      .is(":checked");

    if (isSeasonRadioChecked && is255Selected) {
      $(SELECTORS.platePreview).addClass("kz-255");
      state.maxLength = 7;
      state.maxLengthZeileZwei = 5;
      state.maxLengthZeileEins = 3;
    } else if (isSeasonRadioChecked && is240Selected) {
      $(SELECTORS.platePreview).addClass("kz-240");
      state.maxLength = 6;
      state.maxLengthZeileZwei = 4;
      state.maxLengthZeileEins = 2;
    } else if (is255Selected) {
      $(SELECTORS.platePreview).addClass("kz-255");
      state.maxLength = 8;
      state.maxLengthZeileZwei = 6;
      state.maxLengthZeileEins = 3;
    } else if (is240Selected) {
      $(SELECTORS.platePreview).addClass("kz-240");
      state.maxLength = 7;
      state.maxLengthZeileZwei = 5;
      state.maxLengthZeileEins = 3;
    }
  }

  /**
   * Zeigt Warnungen an, falls das Kennzeichen für die gewählte Größe zu lang ist.
   */
  function updateLengthWarnings() {
    var warningText = "";
    var isValid = true;

    if (state.kzLength > state.maxLength) {
      warningText =
        "Bei Ihrem ausgewählten Kennzeichen-Maß passen auf das Kennzeichen maximal " +
        state.maxLength +
        " Buchstaben und Ziffern. Ihr eingegebenes Kennzeichen besteht jedoch aus " +
        state.kzLength +
        " Buchstaben und Ziffern. Bitte wählen Sie ein größeres Kennzeichen-Maß aus oder geben Sie eine kürzere Buchstaben-Ziffern-Kombination ein.";
      isValid = false;
    } else if (state.zeilezweiLength > state.maxLengthZeileZwei) {
      warningText =
        "Bei Ihrem ausgewählten Kennzeichen-Maß passen in die untere Zeile des Kennzeichens maximal " +
        state.maxLengthZeileZwei +
        " Buchstaben und Ziffern. Ihre Eingabe besteht jedoch aus " +
        state.zeilezweiLength +
        " Buchstaben und Ziffern. Bitte wählen Sie ein größeres Kennzeichen-Maß aus oder geben Sie eine kürzere Buchstaben-Ziffern-Kombination ein.";
      isValid = false;
    } else if (state.zeileeinsLength > state.maxLengthZeileEins) {
      warningText =
        "Bei Ihrem ausgewählten Kennzeichen-Maß passen in die obere Zeile des Kennzeichens maximal " +
        state.maxLengthZeileEins +
        " Buchstaben. Ihre Eingabe für die obere Zeile besteht jedoch aus " +
        state.zeileeinsLength +
        " Buchstaben. Bitte wählen Sie ein größeres Kennzeichen-Maß aus oder geben Sie eine kürzere Buchstaben-Ziffern-Kombination ein.";
      isValid = false;
    }

    if (!isValid) {
      $(SELECTORS.plateWarning).text(warningText).css("display", "block");
      setVisibility(
        SELECTORS.platePreviewDistrict + ", " + SELECTORS.platePreviewLetters + ", " + SELECTORS.platePreviewNumbers,
        false
      );
      setVisibility(SELECTORS.buyButtons, false);
      return;
    }

    $(SELECTORS.plateWarning).hide();
    setVisibility(
      SELECTORS.platePreviewDistrict + ", " + SELECTORS.platePreviewLetters + ", " + SELECTORS.platePreviewNumbers,
      true
    );
    setVisibility(SELECTORS.buyButtons, true);

    if (
      state.kzLength === state.maxLength ||
      state.zeilezweiLength === state.maxLengthZeileZwei
    ) {
      kzEngschrift();
    } else {
      kzMittelschrift();
    }

    if (state.maxLength < 6) {
      kzMittelschrift();
    }
  }

  /**
   * Hauptzähler für alle Kennzeichenfelder.
   */
  function kzZaehler() {
    state.kzLength =
      getValue(SELECTORS.plateDistrictInput).length +
      getValue(SELECTORS.plateLettersInput).length +
      getValue(SELECTORS.plateNumbersInput).length +
      $(SELECTORS.platePreviewSpecial).text().length;

    state.zeilezweiLength =
      getValue(SELECTORS.plateLettersInput).length +
      getValue(SELECTORS.plateNumbersInput).length +
      $(SELECTORS.platePreviewSpecial).text().length;

    state.zeileeinsLength = getValue(SELECTORS.plateDistrictInput).length;

    updateYmqPlateValue();
    kzInputCheck();
    applyLegacyCompactPlateLimits();
    updateLengthWarnings();
    syncLegacyGlobals();

    log(state.kzLength + " KZlänge", state.maxLength + " maxlänge");
  }

  /**
   * Ermittelt die Größenkonfiguration aus dem YMQ-Größenfeld.
   */
  function getSelectedSizePreset() {
    var currentValue = getValue(SELECTORS.ymqSizeSelect);
    var preset = null;

    $.each(SIZE_PRESETS, function (_index, candidate) {
      if (!preset && contains(currentValue, candidate.match)) {
        preset = candidate;
      }
    });

    return preset;
  }

  /**
   * Wendet die CSS-Klasse und Limits einer Größe an.
   */
  function applySizePreset(preset) {
    var adjustedMax;
    var isSpecialVehicleTitle = /Motorrad|Leichtkraft|Traktor/.test(document.title || "");

    if (!preset) {
      return;
    }

    $(SELECTORS.platePreview).removeClass().addClass(preset.cssClass);

    state.maxLength = preset.max;
    state.maxLengthZeileZwei = preset.maxSecond;
    state.maxLengthZeileEins = preset.maxFirst;

    if (isSeasonPlate()) {
      if (typeof preset.seasonMaxFirst === "number") {
        state.maxLengthZeileEins = preset.seasonMaxFirst;
      }

      if (typeof preset.seasonMax === "number") {
        state.maxLength = preset.seasonMax;
      }

      if (!isSpecialVehicleTitle) {
        adjustedMax = state.maxLength - 1;
        state.maxLength = adjustedMax < 0 ? 0 : adjustedMax;
      }
    }

    syncLegacyGlobals();
  }

  /**
   * Wird nach Änderung der Kennzeichengröße aufgerufen.
   * Der kleine Delay bleibt, weil YMQ-Werte oft zeitversetzt aktualisiert.
   */
  function kzSizeChanged() {
    window.setTimeout(function () {
      var preset = getSelectedSizePreset();

      applySizePreset(preset);
      kzZaehler();

      if (typeof window.zubehoerFunktion === "function") {
        window.zubehoerFunktion();
      }
    }, 200);
  }

  /**
   * E-/H-Sonderzeichen setzen.
   */
  function setSpecialSuffix(suffix) {
    state.zusatzzeichen = suffix || "";
    syncLegacyGlobals();

    $(SELECTORS.platePreviewSpecial)
      .text(state.zusatzzeichen)
      .css("display", state.zusatzzeichen ? "inline-block" : "none");

    setVisible("#kz-e-buchstabe-e", state.zusatzzeichen === "E", "inline-block");
    setVisible("#kz-e-buchstabe-h", state.zusatzzeichen === "H", "inline-block");

    kzZaehler();
  }

  /**
   * E-/H-Infobuttons einblenden, wenn Nutzer diese Tasten im Ziffernfeld nutzt.
   */
  function updateSpecialPlateButtonsFromKey(event) {
    var key = event && event.key ? event.key : "";

    if (key === "E" || key === "e") {
      setVisible(SELECTORS.ePlateButton, true);
      setVisible(SELECTORS.hPlateButton, false);
    }

    if (key === "H" || key === "h") {
      setVisible(SELECTORS.hPlateButton, true);
      setVisible(SELECTORS.ePlateButton, false);
    }
  }

  /**
   * Liefertermin von Warenkorb/Produktseite für Klarna übernehmen.
   */
  function syncDeliveryToKlarna() {
    var deliveryHtml = $(".estimateddelivery-cart").html();

    if ($.cookie && typeof deliveryHtml !== "undefined") {
      $.cookie("lieferung", deliveryHtml);
      $("#klarna_shipping").html($.cookie("lieferung"));
    }
  }

  /**
   * Headline über Hash steuern:
   * #head=Berlin&subhead=...
   */
  function updateHeadlineFromHash() {
    var rawHash = window.location.hash ? window.location.hash.substr(1) : "";
    var parts;
    var values = {};

    if (!rawHash) {
      return;
    }

    parts = rawHash.split("&");

    $.each(parts, function (_index, part) {
      var pair = part.split("=");
      var key = pair.shift();

      if (key) {
        values[key] = decodeURIComponent(pair.join("=") || "");
      }
    });

    if (values.head) {
      $("#hl-1")
        .html("Jetzt Kennzeichen f&uuml;r " + values.head + " bestellen &amp; sparen.")
        .css("font-size", "1.9em");
    }

    if (values.subhead) {
      $("#sub-hl").html(values.subhead);
    }
  }

  /**
   * Buttonstatus abhängig vom Zulassungsbezirk setzen.
   */
  function toggleSubmitButtonByDistrict() {
    if (!$(SELECTORS.plateDistrictInput).length) {
      return;
    }

    $(SELECTORS.submitButton).prop(
      "disabled",
      getValue(SELECTORS.plateDistrictInput).trim() === ""
    );
  }

  /**
   * Overlay zeigen, wenn Pflichtfelder fehlen.
   */
  function showCartBtnOverlay() {
    setVisible(SELECTORS.cartOverlay, true);
    setVisible(SELECTORS.inputCheckNotice, true);

    $(SELECTORS.submitButton).prop("disabled", true);
    window.setTimeout(function () {
      $(SELECTORS.submitButton).prop("disabled", true);
    }, 500);
  }

  /**
   * Overlay ausblenden, wenn Pflichtfelder vollständig sind.
   */
  function hideCartBtnOverlay() {
    setVisible(SELECTORS.cartOverlay, false);
    setVisible(SELECTORS.inputCheckNotice, false);

    $(SELECTORS.submitButton).prop("disabled", false);
    window.setTimeout(function () {
      $(SELECTORS.submitButton).prop("disabled", false);
    }, 500);
  }

  /**
   * Prüft, ob Kennzeichen-Pflichtfelder ausgefüllt sind.
   */
  function kzInputCheck() {
    var district;
    var letters;
    var numbers;

    if (!$(SELECTORS.plateLettersInput).length) {
      return;
    }

    district = getValue(SELECTORS.plateDistrictInput).trim();
    letters = getValue(SELECTORS.plateLettersInput).trim();
    numbers = getValue(SELECTORS.plateNumbersInput).trim();

    if (district.length < 1 || letters.length < 1 || numbers.length < 1) {
      showCartBtnOverlay();
      $(SELECTORS.inputCheckNotice).text("Bitte vervollständigen Sie zuerst Ihr Kennzeichen.");
    } else {
      hideCartBtnOverlay();
    }
  }

  /**
   * Packstation-Hinweis vorbereiten.
   */
  function setupPackstationNotice() {
    if (!$("#packstation-hinweis").length && $("#billing-new-address-form").length) {
      $(
        "<p id='packstation-hinweis' style='display:none;'><b style='color:#e05416'>Hinweis:<br>Der Versand an eine DHL Packstation ist nicht möglich</b>, da Bestellungen mit der Deutschen Post als <b>Großbrief + Einschreiben</b> verschickt werden. Ihre Anwesenheit ist bei der Zustellung deshalb nicht erforderlich - Ihre Bestellung wird in neutralem Umschlag in Ihren Briefkasten gelegt. <b>Geben Sie daher bitte Ihre Firmen- oder Privatanschrift an. Vielen Dank.</b></p>"
      ).insertAfter("#billing-new-address-form");
    }
  }

  /**
   * Prüft Packstation im Checkout.
   */
  function packstation() {
    var txt =
      getValue(".tcheckout-step-wrap input.firma") +
      " " +
      getValue(".tcheckout-step-wrap input.adresse");

    if (/packstation/i.test(txt)) {
      // Der alte Code hat den Hinweis bewusst nicht eingeblendet.
      // Bei Bedarf: $("#packstation-hinweis").show("normal");
      return;
    }

    $("#packstation-hinweis").hide("normal");
  }

  /**
   * Zusatzoption in der Zubehörliste finden.
   */
  function getEquipmentOptionElement(optionTitle) {
    var $equipmentOption = $();

    $('.zubehoer label[for^="options_"]').each(function () {
      if (contains($(this).text(), optionTitle)) {
        $equipmentOption = $(this).parent().parent();
        return false;
      }
      return true;
    });

    return $equipmentOption;
  }

  /**
   * Eingabefelder für Zubehör direkt unter die passende Option verschieben.
   */
  function manageEquipmentOption(optionTitle, optionCssClass) {
    var $equipmentOption = getEquipmentOptionElement(optionTitle);
    var $option = $(optionCssClass);
    var isClickLocked = false;

    if (!$equipmentOption.length || !$option.length) {
      return;
    }

    $option.hide().insertAfter($equipmentOption).css("float", "none");

    $equipmentOption.off("click.kfzShopEquipment").on("click.kfzShopEquipment", function () {
      if (!isClickLocked) {
        $option.toggle();
      }

      isClickLocked = true;
      window.setTimeout(function () {
        isClickLocked = false;
      }, 10);
    });
  }

  /**
   * Zulassungsbezirk normalisieren.
   */
  function normalizeDistrictCode(value) {
    return sanitizeDistrict(value);
  }

  /**
   * Findet die Reservierungsdaten zum Zulassungsbezirk.
   */
  function getReservationEntry(code) {
    var normalizedCode = normalizeDistrictCode(code);

    if (Object.prototype.hasOwnProperty.call(RESERVATION_DATA, normalizedCode)) {
      return RESERVATION_DATA[normalizedCode];
    }

    return {
      state: "",
      hint: normalizedCode ? "Bitte Zulassungsbezirk eingeben." : "",
      links: []
    };
  }

  /**
   * Rendert einen Link und das zugehörige Radio-Label.
   */
  function renderReservationSlot(index, entry) {
    var link = entry && entry.links[index - 1] ? entry.links[index - 1] : null;
    var district = link ? asString(link.district) : "";
    var url = link ? asString(link.url) : "";
    var $link = $(SELECTORS.reservationLinkPrefix + index);
    var $radio = $(SELECTORS.reservationRadioPrefix + index);
    var $label = $(SELECTORS.reservationRadioLabelPrefix + index);
    var hasDistrict = district !== "";
    var hasUrl = url !== "";

    $link
      .text(hasDistrict ? "Wunschkennzeichen reservieren - " + district : "")
      .attr("href", url)
      .css("display", hasUrl ? "inline-block" : "none");

    $radio.val(district);

    $label
      .text(district)
      .css("display", hasDistrict ? "block" : "none");
  }

  /**
   * Gewählte Zulassungsstelle in das versteckte Feld schreiben.
   */
  function syncSelectedReservationDistrict() {
    var selectedValue = $(SELECTORS.reservationRadioGroup + ":checked").val();

    if (typeof selectedValue === "undefined") {
      selectedValue = $(SELECTORS.reservationRadioGroup).eq(0).val();
    }

    setValue(SELECTORS.reservationDistrictInput, selectedValue || "");
  }

  /**
   * Reservierungslinks und Bundesland-Plakette aktualisieren.
   */
  function kzReservieren() {
    var code = getValue(SELECTORS.plateDistrictInput) || getValue(SELECTORS.districtCookieInput);
    var entry = getReservationEntry(code);

    $("#kz-p-plaketten").removeClass().addClass(entry.state || "");
    $(SELECTORS.reservationNotice).text(entry.hint || "");

    renderReservationSlot(1, entry);
    renderReservationSlot(2, entry);
    renderReservationSlot(3, entry);
    renderReservationSlot(4, entry);

    $(SELECTORS.reservationRadioGroup).eq(0).prop("checked", true);
    syncSelectedReservationDistrict();

    log(normalizeDistrictCode(code) + " = ", entry.links && entry.links[0] ? entry.links[0].url : "");
    log("Bundesland: " + (entry.state || ""));
  }

  /**
   * Kundenservice-Submit erst einblenden, wenn E-Mail-Feld befüllt ist.
   */
  function setupCustomerServiceSubmitToggle() {
    var checkExist = window.setInterval(function () {
      if ($(".fsSubmit").length) {
        $(".fsSubmit").hide();
        window.clearInterval(checkExist);
      }
    }, 100);
  }

  /**
   * Initiale Produktlogik je URL/Produktklasse.
   */
  function setupProductDefaults() {
    var url = window.location.href;

    if (contains(url, "motorradkennzeichen")) {
      $(SELECTORS.platePreview).addClass("kz-180 zweizeiler");

      window.setTimeout(function () {
        kzSizeChanged();
        applySizePreset(getSelectedSizePreset());
      }, 500);
    }

    $(
      ".product-motorradkennzeichen #kz-preview, " +
        ".product-carbon-motorradkennzeichen #kz-preview, " +
        ".product-3d-motorradkennzeichen-premium #kz-preview"
    ).addClass("zweizeiler kz-180");

    if (contains(url, "e-kennzeichen")) {
      setSpecialSuffix("E");
    }

    if (contains(url, "h-kennzeichen")) {
      setSpecialSuffix("H");
    }

    if (contains(url, "leichtkraftrad")) {
      $(SELECTORS.platePreview).addClass("zweizeiler kz-255");
    }

    if (contains(url, "traktor")) {
      $(SELECTORS.platePreview)
        .addClass("zweizeiler kz-255")
        .css({ color: "rgb(0, 138, 0)", "border-color": "rgb(0, 138, 0)" });
    }

    $(".product-traktor-kennzeichen #kz-preview, .product-leichtkraftrad-kennzeichen #kz-preview")
      .addClass("zweizeiler kz-255");

    if (
      $(
        ".product-traktor-kennzeichen .kz-length select option, " +
          ".product-leichtkraftrad-kennzeichen .kz-length select option"
      )
        .eq(1)
        .is(":checked")
    ) {
      state.maxLength = 8;
      state.maxLengthZeileZwei = 6;
    }

    syncLegacyGlobals();
  }

  /**
   * Lieferzeit-Elemente und Hinweise an Zielpositionen verschieben.
   */
  function moveStaticElements() {
    $(".estimateddelivery").insertAfter(".platzhalter-delivery");
    $(".estimateddelivery-cart").insertAfter(".checkout-types");

    if ($("#profimodus-div").length && $(".kz-anzahl").length) {
      $("#profimodus-div").insertAfter(".kz-anzahl");
    }

    if ($(SELECTORS.plateWarning).length && !$(".kz-length dt .kz-warnung").length) {
      $(SELECTORS.plateWarning).first().clone().appendTo(".kz-length dt");
    }
  }

  /**
   * Cookie für Zulassungsbezirk lesen und Vorschau initialisieren.
   */
  function setupInitialDistrictFromCookie() {
    var district = "";

    if (window.Cookies && typeof window.Cookies.get === "function") {
      district = window.Cookies.get("Zulassungsbezirk") || "";
    } else if ($.cookie) {
      district = $.cookie("Zulassungsbezirk") || "";
    }

    $(SELECTORS.plateInputWrapper + " " + SELECTORS.plateDistrictInput + "," +
      SELECTORS.plateInputWrapper + " " + SELECTORS.plateLettersInput + "," +
      SELECTORS.plateInputWrapper + " " + SELECTORS.plateNumbersInput
    ).val("");

    if (district) {
      setValue(SELECTORS.plateInputWrapper + " " + SELECTORS.plateDistrictInput, district);
      $(SELECTORS.platePreview + " " + SELECTORS.platePreviewDistrict).text(district);
    }

    kzReservieren();
  }

  /**
   * Alle Event-Handler zentral und mit Namespace binden.
   */
  function bindEvents() {
    var $document = $(document);
    var $body = $(SELECTORS.body);

    $(".teaser-bild").off("resize.kfzShop").on("resize.kfzShop", function () {
      log("Teaser-Bild-Größe:" + $(".teaser-bild").height());
    });

    $body
      .off("keyup.kfzShopCustomerService", ".fsFieldEmail")
      .on("keyup.kfzShopCustomerService", ".fsFieldEmail", function () {
        setVisible(".fsSubmit", getValue(this) !== "");
      });

    $(".kennzeichenart li:nth-child(4) label")
      .off("click.kfzShopModal")
      .on("click.kfzShopModal", function () {
        $(
          ".product-autokennzeichen #carbon-kz, " +
            ".product-motorradkennzeichen #carbon-kz, " +
            ".product-e-kennzeichen-elektrofahrzeuge #carbon-kz, " +
            ".product-h-kennzeichen-oldtimer #carbon-kz"
        ).modal({});
      });

    $("#plakette-button").off("click.kfzShopModal").on("click.kfzShopModal", function () {
      $("#plakette-modal").modal({});
    });

    $(".garantie").off("click.kfzShopModal").on("click.kfzShopModal", function () {
      $("#garantie-modal").modal({});
    });

    $(".menu-modal-icon").off("click.kfzShopModal").on("click.kfzShopModal", function () {
      $("#menu-modal").modal({});
    });

    $(".tuv2").off("click.kfzShopModal").on("click.kfzShopModal", function () {
      $("#tuev-modal").modal({});
    });

    $body.off("input.kfzShopDistrict", SELECTORS.plateDistrictInput).on(
      "input.kfzShopDistrict",
      SELECTORS.plateDistrictInput,
      function () {
        var value = sanitizeDistrict(this.value);

        $(this).val(value);
        $(SELECTORS.platePreviewDistrict).text(value);
        pulsePreview(SELECTORS.platePreviewDistrict);

        kzZaehler();
        kzReservieren();
        toggleSubmitButtonByDistrict();
      }
    );

    $body.off("input.kfzShopLetters", SELECTORS.plateLettersInput).on(
      "input.kfzShopLetters",
      SELECTORS.plateLettersInput,
      function () {
        var value = sanitizePlateLetters(this.value);

        $(this).val(value);
        $(SELECTORS.platePreviewLetters).text(value);
        pulsePreview(SELECTORS.platePreviewLetters);

        kzZaehler();
      }
    );

    $body.off("keyup.kfzShopNumbersSpecial", SELECTORS.plateNumbersInput).on(
      "keyup.kfzShopNumbersSpecial",
      SELECTORS.plateNumbersInput,
      function (event) {
        var url = window.location.href;
        var shouldReactToSpecialKey =
          contains(url, "autokennzeichen") ||
          contains(url, "kennzeichen-fur-anhanger-fahrradtrager") ||
          $(".product-haendlerkennzeichen").length > 0;

        if (shouldReactToSpecialKey) {
          updateSpecialPlateButtonsFromKey(event);
        }
      }
    );

    $body.off("input.kfzShopNumbers", SELECTORS.plateNumbersInput).on(
      "input.kfzShopNumbers",
      SELECTORS.plateNumbersInput,
      function () {
        var value = sanitizePlateNumbers(this.value);

        $(this).val(value);
        $(SELECTORS.platePreviewNumbers).text(value);
        pulsePreview(SELECTORS.platePreviewNumbers);

        kzZaehler();
      }
    );

    $("#kzreservieren-btn").off("click.kfzShop").on("click.kfzShop", function () {
      if ($("#schritt1").length) {
        $("html, body").animate({ scrollTop: $("#schritt1").offset().top }, 200);
      }
    });

    $body.off("change.kfzShopSeason", SELECTORS.ymqPlateTypeSelect + ", " + SELECTORS.ymqStartMonthSelect + ", " + SELECTORS.ymqEndMonthSelect).on(
      "change.kfzShopSeason",
      SELECTORS.ymqPlateTypeSelect + ", " + SELECTORS.ymqStartMonthSelect + ", " + SELECTORS.ymqEndMonthSelect,
      function () {
        updateSeasonVisibility();
        updateGreenPlateStyle();

        window.setTimeout(function () {
          kzZaehler();
          kzSizeChanged();
        }, 550);
      }
    );

    $body.off("change.kfzShopSize", SELECTORS.ymqSizeSelect).on(
      "change.kfzShopSize",
      SELECTORS.ymqSizeSelect,
      function () {
        kzSizeChanged();
        kzZaehler();
      }
    );

    $body.off("change.kfzShopLegacyCompact", ".product-traktor-kennzeichen .kz-length select, .product-leichtkraftrad-kennzeichen .kz-length select").on(
      "change.kfzShopLegacyCompact",
      ".product-traktor-kennzeichen .kz-length select, .product-leichtkraftrad-kennzeichen .kz-length select",
      function () {
        $(SELECTORS.platePreview).removeClass();
        applyLegacyCompactPlateLimits();
        kzZaehler();
      }
    );

    $document.off("input.kfzShopParking", SELECTORS.parkingInput).on(
      "input.kfzShopParking",
      SELECTORS.parkingInput,
      function () {
        var value = sanitizeParkingPlate(this.value);

        $(this).val(value);
        $(SELECTORS.parkingPreview).text(value);
        setValue(SELECTORS.hiddenLicenseInput, getValue(SELECTORS.parkingSourceInput).toUpperCase());
      }
    );

    $body.off("input.kfzShopHolder", SELECTORS.holderTextInput).on(
      "input.kfzShopHolder",
      SELECTORS.holderTextInput,
      function () {
        var rawValue = asString(this.value);

        if (rawValue.replace(/ /g, "").length > 50) {
          rawValue = rawValue.substr(0, 50);
          $(this).val(rawValue);
        }

        setValue(SELECTORS.holderHiddenInput, rawValue);
      }
    );

    $body.off("input.kfzShopCookieDistrict", SELECTORS.districtCookieInput).on(
      "input.kfzShopCookieDistrict",
      SELECTORS.districtCookieInput,
      function () {
        var value = sanitizeDistrict(this.value);

        $(SELECTORS.districtCookieInput).val(value);

        if (window.Cookies && typeof window.Cookies.set === "function") {
          window.Cookies.set("Zulassungsbezirk", value);
        } else if ($.cookie) {
          $.cookie("Zulassungsbezirk", value);
        }

        kzReservieren();
      }
    );

    $("#profimodus").off("change.kfzShop").on("change.kfzShop", function () {
      setVisible(".kz-length, .kennzeichenart", $("#profimodus").is(":checked"));
    });

    $body.off("change.kfzShopSubmit keyup.kfzShopSubmit paste.kfzShopSubmit", SELECTORS.plateDistrictInput).on(
      "change.kfzShopSubmit keyup.kfzShopSubmit paste.kfzShopSubmit",
      SELECTORS.plateDistrictInput,
      toggleSubmitButtonByDistrict
    );

    $body.off("keyup.kfzShopPackstation", ".tcheckout-step-wrap input").on(
      "keyup.kfzShopPackstation",
      ".tcheckout-step-wrap input",
      packstation
    );

    $body.off("change.kfzShopReservation", SELECTORS.reservationRadioGroup).on(
      "change.kfzShopReservation",
      SELECTORS.reservationRadioGroup,
      syncSelectedReservationDistrict
    );
  }

  /**
   * Globale Kompatibilitätsfunktionen für vorhandene Inline-Handler.
   */
  function exposeLegacyApi() {
    window.modalschliessen = function () {
      window.alert("Vielen Dank für deine Nachricht!");
      if ($.modal && typeof $.modal.close === "function") {
        $.modal.close();
      }
    };

    window.kzMittelschrift = kzMittelschrift;
    window.kzEngschrift = kzEngschrift;
    window.triggerInputChange = triggerInputChange;
    window.kzZaehler = kzZaehler;
    window.kzSizeChanged = kzSizeChanged;
    window.kzReservieren = kzReservieren;
    window.kzInputCheck = kzInputCheck;
    window.showCartBtnOverlay = showCartBtnOverlay;
    window.hideCartBtnOverlay = hideCartBtnOverlay;
    window.packstation = packstation;

    $.urlParam = function (name) {
      var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(window.location.href);
      return results == null ? null : results[1] || 0;
    };

    window.KfzShop = {
      refreshPlate: kzZaehler,
      refreshSize: kzSizeChanged,
      refreshReservation: kzReservieren,
      setSpecialSuffix: setSpecialSuffix,
      setDebug: function (enabled) {
        state.debug = !!enabled;
      },
      data: {
        reservations: RESERVATION_DATA,
        sizePresets: SIZE_PRESETS
      }
    };
  }

  /**
   * Initialisierung des gesamten Shop-Skripts.
   */
  function init() {
    exposeLegacyApi();
    syncLegacyGlobals();
    setupCustomerServiceSubmitToggle();
    moveStaticElements();
    setupPackstationNotice();
    setupProductDefaults();
    setupInitialDistrictFromCookie();
    bindEvents();

    updateHeadlineFromHash();
    syncDeliveryToKlarna();
    updateSeasonVisibility();
    updateGreenPlateStyle();
    toggleSubmitButtonByDistrict();

    if ($(SELECTORS.plateNumbersInput).length) {
      showCartBtnOverlay();
    }

    manageEquipmentOption("Parkplatzschild", ".ihr-text");
    manageEquipmentOption("Personalisierter Halter", ".ihr-kennzeichenhalter-text");

    window.setTimeout(function () {
      kzSizeChanged();
    }, 550);
  }

  $(init);
})(window.jQuery, window, document);


/**
 * Stand alone polyfill allow only numbers on input of type number.
 *
 * While input filtering is already supported by default by some browsers, maximum length has not been implemented by
 * any. This script will solve both issue and make sure that only digits can be entered in input elements of type
 * number. If the optional attribute `max` is set, it will calculate it's length and mimic the `maxlength` behavior on
 * input of type text.
 *
 * Supports:
 *
 *  - Browsers: IE8+ and any other browsers.
 *
 * Limitations:
 *
 * - Must use an addEventListener polyfill (e.g. https://github.com/nbouvrette/eventListenerPolyfill) for IE8 support.
 * - Must use HTML5shiv (https://github.com/afarkas/html5shiv) for IE8 support.
 *
 * Usage:
 *
 * <input type="number" id="number" min="0" max="100">
 * <script>
 *     var number = document.getElementById("number");
 *     inputTypeNumberPolyfill.polyfillElement(number);
 * </script>
 */
window.inputTypeNumberPolyfill = {
  /**
   * Does the clipboard contain a numerical value?
   *
   * @private
   *
   * @param {Event} event - The paste event triggering this method.
   */
  clipboardIsNumeric: function (event) {
    event = event ? event : window.event;
    var clipboardData = event.clipboardData
      ? event.clipboardData.getData("Text")
      : window.clipboardData.getData("Text");
    var isNumber = /^\d+$/.test(clipboardData);
    return isNumber;
  },

  /**
   * Is the clipboard data bigger than the element's maximum length?
   *
   * @private
   *
   * @param {Event} event - The paste event triggering this method.
   * @param {HTMLElement|HTMLInputElement} element - The HTML element.
   */
  eventIsBlockedByMaxWhenPasting: function (event, element) {
    var maximumValueLength = this.getMaxValueLength(element);
    if (maximumValueLength) {
      event = event ? event : window.event;
      var clipboardData = event.clipboardData
        ? event.clipboardData.getData("Text")
        : window.clipboardData.getData("Text");
      var clipboardDataLength =
        typeof clipboardData == "undefined" ? 0 : clipboardData.length;
      var selectedTextLength = this.getSelectedTextLength(event, element);
      return (
        element.value.length + clipboardDataLength - selectedTextLength >
        maximumValueLength
      );
    }
    return false;
  },

  /**
   * Get the selected text length.
   *
   * @private
   *
   * There are multiple bugs linked to selection in all major current browsers. This method works around the
   * documented problems mentioned below:
   *
   * - Chrome: http://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome
   * - Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=85686
   *
   * @param {Event|KeyboardEvent} event - The event triggering this method.
   * @param {HTMLElement|HTMLInputElement} element - The HTML element.
   *
   * @returns {Number} Returns the selected text length or 0 when unable to get it.
   */
  getSelectedTextLength: function (event, element) {
    var selectionLength = 0;

    try {
      // Used by Firefox and modern IE (using a Chrome workaround).
      selectionLength = element.selectionEnd - element.selectionStart;
      selectionLength =
        typeof selectionLength == "number" && !isNaN(selectionLength)
          ? selectionLength
          : 0;
    } catch (error) {}

    if (!selectionLength) {
      if (window.getSelection) {
        // Used by Chrome.
        var selection = window.getSelection();
        selectionLength =
          selection == "undefined" ? 0 : selection.toString().length;
      } else if (document.selection && document.selection.type != "None") {
        // Used IE8.
        var textRange = document.selection.createRange();
        selectionLength = textRange.text.length;
      }
    }

    return selectionLength;
  },

  /**
   * Is the next typed character blocked by element's maximum length?
   *
   * @private
   *
   * @param {KeyboardEvent} event - The Keyboard event triggering this method.
   * @param {HTMLElement|HTMLInputElement} element - The HTML element.
   */
  eventIsBlockedByMaxWhenTyping: function (event, element) {
    var maximumValueLength = this.getMaxValueLength(element);
    if (maximumValueLength) {
      event = event ? event : window.event;
      var selectedTextLength = this.getSelectedTextLength(event, element);
      var characterLength = this.getCharCodeLength(event);
      return (
        element.value.length - selectedTextLength + characterLength >
        maximumValueLength
      );
    }
    return false;
  },

  /**
   * Does the element have a max attribute set? And if it is valid, what is its length.
   *
   * @private
   *
   * @param {HTMLElement|HTMLInputElement} element - The HTML element.
   */
  getMaxValueLength: function (element) {
    var maximumValue = element.getAttribute("max");
    if (!maximumValue || !/^\d+$/.test(maximumValue)) {
      return 0;
    } else {
      return maximumValue.length;
    }
  },

  /**
   * Is the event's character a digit?
   *
   * @private
   *
   * @param {KeyboardEvent} event - The Keyboard event triggering this method.
   */
  eventKeyIsDigit: function (event) {
    event = event ? event : window.event;
    var keyCode = event.which ? event.which : event.keyCode;
    return this.codeIsADigit(keyCode) || this.charCodeIsAllowed(event);
  },

  /**
   * Is a given keyboard event code (charCode or keyCode) a digit?
   *
   * @private
   *
   * @param {Number|Object} code - The Keyboard event key code.
   */
  codeIsADigit: function (code) {
    var stringCode = String.fromCharCode(code);
    return /^\d$/.test(stringCode);
  },

  /**
   * Is the charCode of this event allowed?
   *
   * @private
   *
   * Some browsers already filter keys for input of type number which means some `onkeypress` event will never get
   * triggered. For other browsers (e.g. Firefox) we need to filter which keys are pressed to only allow digits and
   * any other non typeable keys. There are 3 types of keys we want to let go through:
   *
   * - Digits.
   * - Non typeable characters (moving arrows, backspace, del, tab, etc.).
   * - Key combinations (alt, ctrl, shift, etc) - used for copy paste and other functionalities.
   *
   * @param {KeyboardEvent} event - The Keyboard event triggering this method.
   */
  charCodeIsAllowed: function (event) {
    event = event ? event : window.event;
    var charCode = event.charCode;
    var keyCode = event.which ? event.which : event.keyCode;
    charCode = typeof charCode === "undefined" ? keyCode : charCode; // IE8 fallback.

    if (charCode === 0) {
      // Non typeable characters are allowed.
      return true;
    } else if (
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.metaKey
    ) {
      // All combinations are allowed.
      return true;
    } else if (!this.codeIsADigit(charCode)) {
      // Any other character that is not a digit will be blocked.
      return false;
    }

    // The only characters left are numeric, so we let them through.
    return true;
  },

  /**
   * Get the character code length.
   *
   * @private
   *
   * @param {KeyboardEvent} event - The Keyboard event triggering this method.
   */
  getCharCodeLength: function (event) {
    event = event ? event : window.event;
    var charCode = event.charCode;
    var keyCode = event.which ? event.which : event.keyCode;
    charCode = typeof charCode === "undefined" ? keyCode : charCode; // IE8 fallback.

    if (charCode === 0) {
      // Non typeable characters have no length.
      return 0;
    } else if (
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.metaKey
    ) {
      // All combinations have no length.
      return 0;
    } else if (!this.codeIsADigit(charCode)) {
      // All non-allowed characters have 0 length (because they will be blocked).
      return 0;
    }

    return 1; // By default a character has a length of 1.
  },

  /**
   * Polyfill a given element.
   *
   * @param {HTMLElement|HTMLInputElement} element - The HTML element.
   */
  polyfillElement: function (element) {
    element.addEventListener("keypress", function (event) {
      if (
        !inputTypeNumberPolyfill.eventKeyIsDigit(event) ||
        inputTypeNumberPolyfill.eventIsBlockedByMaxWhenTyping(event, element)
      ) {
        event.preventDefault();
      }
    });

    element.addEventListener("paste", function (event) {
      if (
        !inputTypeNumberPolyfill.clipboardIsNumeric(event) ||
        inputTypeNumberPolyfill.eventIsBlockedByMaxWhenPasting(event, element)
      ) {
        event.preventDefault();
      }
    });
  },
};
